const messages = {
  pt: {
    translations: {
      "signup": {
            "title": "Cadastre-se",
            "toasts": {
                  "success": "Usuário criado com sucesso! Faça seu login!!!.",
                  "disabled": "Cadastro de usuários está desabilitado no momento. Por favor, tente novamente mais tarde.",
                  "fail": "Erro ao criar usuário. Verifique os dados informados."
            },
            "form": {
                  "name": "Nome",
                  "email": "Email",
                  "password": "Senha",
                  "company": "Nome da Organização",
                  "phone": "Whatsapp (DDD + NÚMERO)"
            },
            "buttons": {
                  "submit": "Cadastrar",
                  "login": "Já tem uma conta? Entre!",
                  "continue": "Continuar"
            },
            "choosePlanTitle": "Escolha seu Plano",
            "choosePlanSubtitle": "Selecione o plano ideal para sua empresa",
            "idealForCompany": "Ideal para sua empresa",
            "planMetaUsers": "Até {{users}} usuários",
            "planMetaConnections": "Até {{connections}} conexões",
            "alreadyHaveAccount": "Já tem uma conta?",
            "loginLink": "Entre!"
      },
      "ticketInfo": {
            "copyPhone": "Copiar telefone",
            "quickMessages": "Respostas rápidas",
            "phonecopied": "Telefone copiado para área de transferência!",
            "noPhone": "Nenhum telefone disponível para copiar",
            "copyError": "Erro ao copiar telefone"
      },
      "birthdayModal": {
            "title": "🎉 Parabéns!",
            "subtitle": "Hoje é um dia especial!",
            "loading": "Carregando aniversariantes...",
            "userLabel": "Usuário do Sistema",
            "contactLabel": "Contato",
            "sendButton": "Enviar Parabéns",
            "sending": "Enviando...",
            "alreadySent": "Mensagem já enviada",
            "remindLater": "Lembrar mais tarde",
            "understood": "Entendi, obrigado!",
            "messageSentSuccess": "Mensagem de parabéns enviada para {{name}}! 🎉",
            "loadError": "Erro ao carregar aniversariantes",
            "sendError": "Erro ao enviar mensagem de aniversário",
            "alreadySentToday": "Mensagem de aniversário já foi enviada hoje para este contato",
            "ageYears": "{{age}} ano",
            "ageYearsPlural": "{{age}} anos",
            "you": "(Você!)"
      },
      "login": {
            "title": "Login",
            "welcome": "Bem-vindo de volta",
            "loginInstruction": "Entre com seus dados para acessar sua conta",
            "form": {
                  "email": "Email",
                  "password": "Senha",
                  "button": "Acessar"
            },
            "buttons": {
                  "submit": "Login",
                  "register": "Cadastre-se"
            },
            "subtitle": "Entre com suas credenciais para acessar o sistema",
            "links": {
                  "forgotPassword": "Esqueceu a senha?"
            },
            "footer": {
                  "allRightsReserved": "Todos os direitos reservados."
            }
      },
      "companies": {
            "title": "Cadastrar Empresa",
            "form": {
                  "name": "Nome da Empresa",
                  "plan": "Plano",
                  "token": "Token",
                  "submit": "Cadastrar",
                  "success": "Empresa criada com sucesso!"
            }
      },
      "auth": {
            "toasts": {
                  "success": "Login efetuado com sucesso!",
                  "sessionExpired": "Sua sessão foi encerrada porque você acessou de outro dispositivo."
            },
            "dueDate": {
                  "expiration": "Sua assinatura expira em",
                  "days": "dias!",
                  "day": "dia!",
                  "expirationToday": "Sua assinatura expira hoje!"
            },
            "token": "Token"
      },
      "dashboard": {
            "filters": "Filtros",
            "filter": "FILTRAR ",
            "tabs": {
                  "realtime": "Tempo Real",
                  "panel": "Painel",
                  "followup": "Painel FollowUP",
                  "reports": "Relatórios"
            },
            "charts": {
                  "perDay": {
                        "title": "Atendimentos hoje: "
                  }
            },
            "cards": {
                  "inAttendance": "Em Atendimento",
                  "waiting": "Aguardando",
                  "activeAttendants": "Atendentes Ativos",
                  "finalized": "Finalizados",
                  "newContacts": "Novos Contatos",
                  "totalReceivedMessages": "Mensagens Recebidas",
                  "totalSentMessages": "Mensagens Enviadas",
                  "averageServiceTime": "T.M. de Atendimento",
                  "averageWaitingTime": "T.M. de Espera",
                  "status": "Status (Atual)",
                  "activeTickets": "Tickets Ativos",
                  "passiveTickets": "Tickets Passivos",
                  "groups": "Grupos"
            },
            "users": {
                  "name": "Nome",
                  "numberAppointments": "Quantidade de Atendimentos",
                  "statusNow": "Atual",
                  "totalCallsUser": "Total de atendimentos por usuario",
                  "totalAttendances": "Total de atendimentos"
            },
            "date": {
                  "initialDate": "Data Inicial",
                  "finalDate": "Data Final"
            },
            "licence": {
                  "available": "Disponível até"
            },
            "assessments": {
                  "totalCalls": "Total de Atendimentos",
                  "callsWaitRating": "Aguardando avaliação",
                  "callsWithoutRating": "Atendimentos sem avaliação",
                  "ratedCalls": "Atendimentos avaliados",
                  "evaluationIndex": "Índice de avaliação",
                  "score": "Pontuação",
                  "prosecutors": "Satisfeitos",
                  "neutral": "Neutros",
                  "detractors": "Insatisfeitos"
            },
            "title": "Dashboard",
            "subtitle": "Visão geral do atendimento",
            "buttons": {
                  "refresh": "Atualizar",
                  "filter": "Filtrar",
                  "showFilters": "Mostrar Filtros",
                  "hideFilters": "Ocultar Filtros"
            },
            "sections": {
                  "indicators": "Indicadores",
                  "satisfactionSurvey": "Pesquisa de satisfação",
                  "tickets": "Atendimentos",
                  "ratingIndex": "Índice de avaliação",
                  "attendants": "Atendentes"
            },
            "indicators": {
                  "totalToday": "Total Hoje",
                  "pending": "Aguardando",
                  "inProgress": "Em Atendimento",
                  "finished": "Finalizados",
                  "onlineAttendants": "Atendentes Online",
                  "onlineTeam": "Equipe online",
                  "avgWaitTime": "Tempo Médio de Espera",
                  "waitMeta": "Meta: menos de 1 min",
                  "avgSupportTime": "Tempo Médio de Atendimento",
                  "supportMeta": "Meta: menos de 5 min"
            },
            "nps": {
                  "score": "Score",
                  "satisfied": "Satisfeitos",
                  "neutral": "Neutros",
                  "unsatisfied": "Insatisfeitos"
            },
            "attendances": {
                  "total": "Total de Atendimentos",
                  "awaitingRating": "Aguardando avaliação",
                  "withoutRating": "Atendimentos sem avaliação",
                  "withRating": "Atendimentos avaliados"
            }
      },
      "reports": {
            "title": "Relatórios de Atendimentos",
            "startDate": "Data Inicial",
            "endDate": "Data final",
            "table": {
                  "id": "Ticket",
                  "user": "Usuário",
                  "dateOpen": "Data Abertura",
                  "dateClose": "Data Fechamento",
                  "NPS": "NPS",
                  "status": "Status",
                  "whatsapp": "Conexão",
                  "queue": "Fila",
                  "actions": "Ações",
                  "lastMessage": "Últ. Mensagem",
                  "contact": "Cliente",
                  "supportTime": "Tempo de Atendimento"
            },
            "buttons": {
                  "filter": "Aplicar Filtro",
                  "onlyRated": "Apenas Avaliados"
            },
            "searchPlaceholder": "Pesquisar..."
      },
      "todo": {
            "newTask": "Nova Tarefa",
            "add": "Adicionar",
            "task": "Tarefas"
      },
      "contactImportWpModal": {
            "title": "Exportar Contatos para o Excel",
            "buttons": {
                  "downloadModel": "Download modelo do excel para importação",
                  "closed": "Fechar",
                  "import": "Selecione o arquivo do excel para importar Contatos"
            }
      },
      "connections": {
            "title": "Conexões",
            "waitConnection": "Aguarde... Suas conexões serão reiniciadas!",
            "newConnection": "Nova Conexão",
            "restartConnections": "Reiniciar Conexões",
            "callSupport": "Chamar Suporte",
            "connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers": " Conecte seus canais de atendimento para receber mensagens e iniciar conversas com seus clientes.",
            "client": "Cliente",
            "connectedConnections": " Conexões conectadas ",
            "disconnectedConnections": "Conexões desconectadas ",
            "totalConnections": " Total de Conexões",
            "total": "Total",
            "connections": "Conexões de:",
            "status": {
                  "CONNECTED": "Conectado",
                  "OPENING": "Abrindo",
                  "DISCONNECTED": "Desconectado",
                  "PENDING": "Pendente",
                  "TIMEOUT": "Tempo Esgotado",
                  "PAIRING": "Pareando",
                  "qrcode": "QR Code"
            },
            "toasts": {
                  "deleted": "Conexão excluída com sucesso!",
                  "closedimported": "Estamos fechando os tickets importados, por favor aguarde uns instantes"
            },
            "confirmationModal": {
                  "closedImportedTitle": "Fechar tickets importados",
                  "closedImportedMessage": "Se você confirmar todos os tickets importados serão fechados",
                  "deleteTitle": "Deletar",
                  "deleteMessage": "Você tem certeza? Essa ação não pode ser revertida.",
                  "disconnectTitle": "Desconectar",
                  "disconnectMessage": "Tem certeza? Você precisará ler o QR Code novamente."
            },
            "buttons": {
                  "add": "Adicionar Conexão",
                  "disconnect": "desconectar",
                  "tryAgain": "Tentar novamente",
                  "qrcode": "QR CODE",
                  "newQr": "Novo QR CODE",
                  "closedImported": "Fechar todos os tickets Importados",
                  "preparing": "Preparando mensagens para importação",
                  "importing": "Importando Mensagens do WhatsApp",
                  "processed": "Processado",
                  "in": "de",
                  "connecting": "Conectando",
                  "transferTickets": "Transferir Tickets"
            },
            "typography": {
                  "processed": "Processado",
                  "in": "de",
                  "date": "Data da mensagem"
            },
            "toolTips": {
                  "disconnected": {
                        "title": "Falha ao iniciar sessão do WhatsApp",
                        "content": "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code"
                  },
                  "qrcode": {
                        "title": "Esperando leitura do QR Code",
                        "content": "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão"
                  },
                  "connected": {
                        "title": "Conexão estabelecida!"
                  },
                  "timeout": {
                        "title": "A conexão com o celular foi perdida",
                        "content": "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code"
                  }
            },
            "table": {
                  "name": "Nome",
                  "status": "Status",
                  "lastUpdate": "Última atualização",
                  "default": "Padrão",
                  "actions": "Ações",
                  "session": "Sessão",
                  "number": "Número do Whatsapp",
                  "color": "Cor",
                  "receiveComments": "Receber Comentários"
            },
            "receiveComments": {
                  "title": "Receber Comentários",
                  "enabled": "Recebimento de comentários habilitado",
                  "disabled": "Recebimento de comentários desabilitado",
                  "tooltip": {
                        "enabled": "Comentários estão sendo recebidos. Clique para desabilitar.",
                        "disabled": "Comentários não estão sendo recebidos. Clique para habilitar."
                  }
            },
            "stats": {
                  "sent": "Enviadas",
                  "received": "Recebidas",
                  "dailyLimit": "Limite diário",
                  "msgPerDay": "msg/dia"
            },
            "transferModal": {
                  "title": "Transferência de Tickets",
                  "desc": "Selecione a conexão de origem e a de destino. Todos os atendimentos ativos serão movidos.",
                  "source": "Origem",
                  "destination": "Destino",
                  "cancel": "Cancelar",
                  "transfer": "Transferir"
            }
      },
      "showTicketOpenModal": {
            "title": {
                  "header": "Atendimento Existente"
            },
            "form": {
                  "message": "Este contato já está em atendimento:",
                  "user": "Atendente",
                  "queue": "Fila",
                  "messageWait": "Este contato já está aguardando atendimento. Veja na aba Aguardando!"
            }
      },
      "showTicketLogModal": {
            "title": {
                  "header": "Logs"
            },
            "options": {
                  "create": "Ticket criado.",
                  "chatBot": "ChatBot iniciado.",
                  "queue": " - Fila definida.",
                  "open": " iniciou o atendimento.",
                  "access": "acessou o ticket.",
                  "transfered": "transferiu o ticket.",
                  "receivedTransfer": "recebeu o ticket transferido.",
                  "pending": "devolveu a fila.",
                  "closed": "fechou o ticket",
                  "reopen": "reabriu o ticket",
                  "redirect": "- redirecionado",
                  "clientClosed": "Cliente fechou o ticket"
            }
      },
      "whatsappModal": {
            "title": {
                  "add": "Adicionar Conexão",
                  "edit": "Editar Conexão"
            },
            "tabs": {
                  "general": "Geral",
                  "messages": "Mensagens",
                  "assessments": "NPS",
                  "integrations": "Integrações",
                  "schedules": "Horário de expediente",
                  "defaultFlow": "Fluxo Padrão"
            },
            "form": {
                  "importOldMessagesEnable": "Importar mensagens do aparelho",
                  "importOldMessages": "Data de inicio da importação",
                  "importRecentMessages": "Data de termino da importação",
                  "importOldMessagesGroups": "Importar mensagens de grupo",
                  "closedTicketsPostImported": "Encerrar tickets após importação",
                  "name": "Nome",
                  "queueRedirection": "Redirecionamento de Fila",
                  "queueRedirectionDesc": "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
                  "default": "Padrão",
                  "group": "Permitir grupos",
                  "timeSendQueue": "Tempo em minutos para redirecionar para fila",
                  "importAlert": "ATENÇÃO: Ao salvar, sua conexão será encerrada, será necessário ler novamente o QR Code para importar as mensagens",
                  "groupAsTicket": "Tratar grupos como ticket",
                  "timeCreateNewTicket": "Criar novo ticket em x minutos",
                  "maxUseBotQueues": "Enviar bot x vezes",
                  "maxUseInactiveTime": "Enviar flow de inatividade x vezes",
                  "timeUseBotQueues": "Enviar bot em x minutos",
                  "timeToReturnQueue": "Minutos para retornar a fila",
                  "timeAwaitActiveFlow": "Tempo para aguardar ativação do fluxo",
                  "expiresTicket": "Encerrar chats abertos após x minutos",
                  "expiresTicketNPS": "Encerrar chats aguardando avaliação após x minutos",
                  "maxUseBotQueuesNPS": "Quantidade máxima de vezes que a avaliaçao vai ser enviada",
                  "closeLastMessageOptions1": "Do atendente/Cliente",
                  "closeLastMessageOptions2": "Do atendente",
                  "outOfHoursMessage": "Mensagem de fora de expediente",
                  "greetingMessage": "Mensagem de saudação",
                  "complationMessage": "Mensagem de conclusão",
                  "lgpdLinkPrivacy": "Link para política de privacidade",
                  "lgpdMessage": "Mensagem de saudaçao LGPD",
                  "lgpdDeletedMessages": "Ofuscar mensagem apagada pelo contato",
                  "lgpdSendMessage": "Sempre solicitar confirmação do contato",
                  "ratingMessage": "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
                  "token": "Token para integração externa",
                  "sendIdQueue": "Fila",
                  "inactiveMessage": "Mensagem de inatividade",
                  "timeInactiveMessage": "Tempo em minutos para envio do aviso de inatividade",
                  "flowInactiveTime": "Tempo para envio do flow de inatividade",
                  "whenExpiresTicket": "Encerrar chats abertos quando última mensagem for",
                  "expiresInactiveMessage": "Mensagem de encerramento por inatividade",
                  "prompt": "Prompt",
                  "collectiveVacationEnd": "Data final",
                  "collectiveVacationStart": "Data inicial",
                  "collectiveVacationMessage": "Mensagem de férias coletivas",
                  "queueIdImportMessages": "Fila para importar as mensagens",
                  "isOficial": "Oficial",
                  "phone_number_id": "ID Número de telefone",
                  "waba_id": "Waba ID",
                  "send_token": "Token de envio",
                  "business_id": "ID do negócio",
                  "phone_number": "Número de telefone",
                  "triggerIntegrationOnClose": "Disparar Integração ao Encerrar Ticket",
                  "enableIntegration": "Habilitar Integração",
                  "externalIntegrationTokenTitle": "Token para integração externa",
                  "welcomeFlowTitle": "Fluxo de boas vindas",
                  "welcomeFlowDesc": "Este fluxo é disparado apenas para novos contatos, pessoas que você não possui em sua lista de contatos e que mandaram uma mensagem",
                  "defaultResponseFlowTitle": "Fluxo de resposta padrão",
                  "defaultResponseFlowDesc": "Resposta Padrão é enviada com qualquer caractere diferente de uma palavra chave. ATENÇÃO! Será disparada se o atendimento ja estiver fechado.",
                  "disabledOption": "Desabilitado"
            },
            "buttons": {
                  "okAdd": "Adicionar",
                  "okEdit": "Salvar",
                  "cancel": "Cancelar"
            },
            "menuItem": {
                  "enabled": "Habilitado",
                  "disabled": "Desabilitado",
                  "minutes": "minutos"
            },
            "success": "Conexão salvo com sucesso.",
            "errorSendQueue": "Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
            "errorExpiresNPS": "É obrigado informar um tempo para avaliação quando se utiliza o NPS.",
            "errorRatingMessage": "É obrigado informar uma mensagem de avaliação quando se utiliza o NPS."
      },
      "qrCode": {
            "message": "Leia o QrCode para iniciar a sessão"
      },
      "contacts": {
            "title": "Contatos",
            "toasts": {
                  "deleted": "Contato excluído com sucesso!"
            },
            "searchPlaceholder": "Pesquisar...",
            "conversationFlows": " Fluxos de Conversa",
            "addFlow": "Adicionar Fluxo",
            "editFlow": "Editar Fluxo ",
            "confirmationModal": {
                  "deleteTitle": "Deletar ",
                  "importTitlte": "Importar contatos",
                  "exportContact": "Exportar contatos",
                  "deleteMessage": "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
                  "blockContact": "Tem certeza que deseja bloquear este contato?",
                  "unblockContact": "Tem certeza que deseja desbloquear este contato?",
                  "importMessage": "Deseja importar todos os contatos do telefone?",
                  "importChat": "Importar Conversas",
                  "wantImport": "Deseja importar todas as conversas do telefone?"
            },
            "buttons": {
                  "import": "Importar Contatos",
                  "add": "Adicionar Contato",
                  "export": "Exportar Contato"
            },
            "loading": "Carregando...",
            "loadMore": "Carregar Mais",
            "table": {
                  "name": "Nome",
                  "whatsapp": "Conexão",
                  "email": "Email",
                  "actions": "Ações",
                  "lastMessage": "Última Mensagem",
                  "wallet": "Carteira",
                  "avatar": "Foto",
                  "unassigned": "Não atribuído"
            },
            "menu": {
                  "importYourPhone": "Importar do aparelho padrão",
                  "importToExcel": "Importar / Exportar do Excel",
                  "importexport": "IMPORTAR / EXPORTAR"
            },
            "tagsFilterPlaceholder": "Filtro por Tags"
      },
      "forwardMessage": {
            "text": "Encaminhada"
      },
      "forwardMessageModal": {
            "title": "Encaminhar mensagem",
            "buttons": {
                  "ok": "Encaminhar"
            }
      },
      "promptModal": {
            "form": {
                  "name": "Nome",
                  "prompt": "Prompt",
                  "voice": "Voz",
                  "voiceMode": "Estratégia de Voz",
                  "voicePriority": "Prioridade",
                  "max_tokens": "Máximo de Tokens na resposta",
                  "temperature": "Temperatura",
                  "apikey": "API Key",
                  "max_messages": "Máximo de mensagens no Histórico",
                  "voiceKey": "Chave da API de Voz",
                  "voiceRegion": "Região de Voz",
                  "voiceConfigTitle": "Configuração de Voz",
                  "voiceStrategy": "Estratégia de Voz",
                  "voiceOnly": "Só Voz",
                  "textOnly": "Só Texto",
                  "textAndVoice": "Texto e Voz",
                  "priority": "Prioridade",
                  "prioritizeText": "Priorizar Texto",
                  "prioritizeVoice": "Priorizar Voz",
                  "responseVoiceOpenAI": "Voz da Resposta (OpenAI)",
                  "responseVoiceAzure": "Voz da Resposta (Azure)",
                  "voiceApiKey": "Chave API de Voz",
                  "voiceRegionAzure": "Região de Voz (Azure)",
                  "chatConfigTitle": "Configuração de Chat"
            },
            "success": "Prompt salvo com sucesso!",
            "title": {
                  "add": "Adicionar Prompt",
                  "edit": "Editar Prompt"
            },
            "buttons": {
                  "okAdd": "Adicionar",
                  "okEdit": "Salvar",
                  "cancel": "Cancelar"
            }
      },
      "prompts": {
            "title": "Prompts",
            "table": {
                  "name": "Nome",
                  "queue": "Setor/Fila",
                  "max_tokens": "Máximo Tokens Resposta",
                  "actions": "Ações"
            },
            "confirmationModal": {
                  "deleteTitle": "Excluir",
                  "deleteMessage": "Você tem certeza? Essa ação não pode ser revertida!"
            },
            "buttons": {
                  "add": "Adicionar Prompt"
            }
      },
      "contactModal": {
            "title": {
                  "add": "Adicionar contato",
                  "edit": "Editar contato"
            },
            "form": {
                  "mainInfo": "Dados do contato",
                  "extraInfo": "Informações adicionais",
                  "name": "Nome",
                  "number": "Número do Whatsapp",
                  "email": "Email",
                  "extraName": "Nome do campo",
                  "extraValue": "Valor",
                  "chatBotContact": "Desabilitar chatbot",
                  "termsLGDP": "Termos LGPD aceito em:",
                  "whatsapp": "Conexão Origem: ",
                  "assignWallet": "Carteira de Cliente",
                  "lidHelperText": "Identificador do dispositivo vinculado",
                  "birthDate": "Data de Nascimento",
                  "birthDateHelperText": "Data de nascimento para mensagens automáticas de aniversário",
                  "searchUserMinChars": "Digite pelo menos 3 caracteres para buscar",
                  "searching": "Buscando...",
                  "userHasNoQueues": "Usuário não possui filas associadas",
                  "selectUserFirst": "Selecione um usuário primeiro",
                  "floupActive": "Floup ativo",
                  "noActiveFloup": "Nenhum Floup ativo",
                  "contactNotInFloup": "Este contato não está em nenhum Floup no momento"
            },
            "buttons": {
                  "addExtraInfo": "Adicionar informação",
                  "okAdd": "Adicionar",
                  "okEdit": "Salvar",
                  "cancel": "Cancelar"
            },
            "success": "Contato salvo com sucesso.",
            "walletLinked": "Contato vinculado à sua carteira com sucesso!",
            "walletError": "Usuário não possui filas associadas",
            "saveFirst": "Contato deve ser salvo primeiro"
      },
      "wallets": {
            "title": "Carteiras de Contatos",
            "searchPlaceholder": "Buscar contatos...",
            "filterByUser": "Filtrar por Usuário",
            "allUsers": "Todos os usuários",
            "contact": "Contato",
            "user": "Usuário",
            "queue": "Fila",
            "phone": "Telefone",
            "email": "Email",
            "actions": "Ações",
            "editWallet": "Editar Carteira",
            "selectUser": "Selecionar Usuário",
            "selectQueue": "Selecionar Fila",
            "selectUserAndQueue": "Selecione um usuário e uma fila",
            "cancel": "Cancelar",
            "save": "Salvar",
            "confirmDeleteTitle": "Confirmar Exclusão",
            "confirmDeleteMessage": "Tem certeza que deseja remover este contato da carteira?",
            "deleteSuccess": "Contato removido da carteira com sucesso!",
            "updateSuccess": "Carteira atualizada com sucesso!",
            "wallet": "Carteira"
      },
      "queueModal": {
            "title": {
                  "queueData": "Dados da fila",
                  "text": "Horários de atendimento",
                  "add": "Adicionar fila",
                  "edit": "Editar fila",
                  "confirmationDelete": "Tem certeza? Todas as opções de integrações serão deletadas."
            },
            "form": {
                  "name": "Nome",
                  "color": "Cor",
                  "orderQueue": "Ordem da fila (Bot)",
                  "rotate": "Rodízio",
                  "timeRotate": "Tempo de Rodízio",
                  "typeRandomMode": "Tipo de rodízio",
                  "greetingMessage": "Mensagem de saudação",
                  "complationMessage": "Mensagem de conclusão",
                  "outOfHoursMessage": "Mensagem de fora de expediente",
                  "token": "Token",
                  "integrationId": "Integração",
                  "fileListId": "Lista de arquivos",
                  "closeTicket": "Fechar ticket",
                  "randomizeImmediate": "Randomizar Automaticamente (Imediato)",
                  "queueType": "Tipo de menu",
                  "message": "Mensagem de retorno",
                  "queue": "Fila para transferência",
                  "integration": "Integração",
                  "file": "Lista de arquivos"
            },
            "buttons": {
                  "okAdd": "Adicionar",
                  "okEdit": "Salvar",
                  "cancel": "Cancelar"
            },
            "bot": {
                  "title": "Opções",
                  "toolTipTitle": "Adicione opções para construir um chatbot",
                  "toolTip": "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
                  "selectOption": "Selecione uma opção",
                  "text": "Texto",
                  "attendent": "Atendente",
                  "queue": "Fila",
                  "integration": "Integração",
                  "file": "Arquivo",
                  "toolTipMessageTitle": "A mensagem é obrigatória para seguir ao próximo nível",
                  "toolTipMessageContent": "A mensagem é obrigatória para seguir ao próximo nível",
                  "selectUser": "Selecione um Usuário",
                  "selectQueue": "Selecione uma Fila",
                  "selectIntegration": "Selecione uma Integração",
                  "addOptions": "Adicionar opções"
            },
            "serviceHours": {
                  "dayWeek": "Dia da semana",
                  "startTimeA": "Hora Inicial - Turno A",
                  "endTimeA": "Hora Final - Turno A",
                  "startTimeB": "Hora Inicial - Turno B",
                  "endTimeB": "Hora Final - Turno B",
                  "monday": "Segunda-feira",
                  "tuesday": "Terça-feira",
                  "wednesday": "Quarta-feira",
                  "thursday": "Quinta-feira",
                  "friday": "Sexta-feira",
                  "saturday": "Sábado",
                  "sunday": "Domingo"
            }
      },
      "queueIntegrationModal": {
            "title": {
                  "add": "Adicionar projeto",
                  "edit": "Editar projeto"
            },
            "form": {
                  "id": "ID",
                  "type": "Tipo",
                  "name": "Nome",
                  "projectName": "Nome do Projeto",
                  "language": "Linguagem",
                  "jsonContent": "JsonContent",
                  "urlN8N": "URL",
                  "typebotSlug": "Typebot - Slug",
                  "typebotExpires": "Tempo em minutos para expirar uma conversa",
                  "typebotKeywordFinish": "Palavra para finalizar o ticket",
                  "typebotKeywordRestart": "Palavra para reiniciar o fluxo",
                  "typebotRestartMessage": "Mensagem ao reiniciar a conversa",
                  "typebotUnknownMessage": "Mensagem de opção inválida",
                  "typebotDelayMessage": "Intervalo (ms) entre mensagens"
            },
            "buttons": {
                  "okAdd": "Adicionar",
                  "okEdit": "Salvar",
                  "cancel": "Cancelar",
                  "test": "Testar Bot"
            },
            "messages": {
                  "testSuccess": "Integração testada com sucesso!",
                  "addSuccess": "Integração adicionada com sucesso.",
                  "editSuccess": "Integração editada com sucesso."
            }
      },
      "userModal": {
            "warning": "Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!",
            "title": {
                  "add": "Adicionar usuário",
                  "edit": "Editar usuário",
                  "updateImage": "Atualizar imagem",
                  "removeImage": "Excluir imagem"
            },
            "form": {
                  "name": "Nome",
                  "email": "Email",
                  "password": "Senha",
                  "farewellMessage": "Mensagem de despedida ao encerrar o atendimento",
                  "profile": "Perfil",
                  "startWork": "Inicio de trabalho",
                  "endWork": "Fim de trabalho",
                  "whatsapp": "Conexão Padrão",
                  "allTicketEnable": "Habilitado",
                  "allTicketDisable": "Desabilitado",
                  "allTicket": "Visualizar chamados sem fila",
                  "allowGroup": "Permitir Grupos",
                  "defaultMenuOpen": "Aberto",
                  "defaultMenuClosed": "Fechado",
                  "defaultMenu": "Menu padrão",
                  "menuStyleLabel": "Estilo do Menu",
                  "menuStyleVertical": "Vertical (Lateral)",
                  "menuStyleHorizontal": "Horizontal (Topo)",
                  "defaultTheme": "Tema Padrão",
                  "defaultThemeDark": "Escuro",
                  "defaultThemeLight": "Claro",
                  "allHistoric": "Ver conversas de outras filas",
                  "allHistoricEnabled": "Habilitado",
                  "allHistoricDisabled": "Desabilitado",
                  "allUserChat": "Ver conversas de outros usuários",
                  "userClosePendingTicket": "Permitir fechar tickets pendentes",
                  "allowSeeMessagesInPendingTickets": "Permitir ver tickets pendentes",
                  "showReturnQueueButton": "Mostrar botão de devolver para fila",
                  "showTransferTicketButton": "Mostrar botão de transferir ticket",
                  "showDashboard": "Ver Dashboard",
                  "allowRealTime": "Ver Painel de Atendimentos",
                  "allowConnections": "Permitir ações nas conexões",
                  "showContacts": "Ver contatos",
                  "showCampaign": "Ver campanhas",
                  "showFlow": "Ver automações",
                  "connections": "Conexões",
                  "birthDate": "Data de Nascimento",
                  "closingWithSaleValue": "Finalização com Valor de Venda",
                  "disabled": "Desabilitado",
                  "enabled": "Habilitado"
            },
            "tabs": {
                  "general": "Geral",
                  "permissions": "Permissões"
            },
            "buttons": {
                  "okAdd": "Adicionar",
                  "okEdit": "Salvar",
                  "cancel": "Cancelar",
                  "addImage": "Adicionar Imagem",
                  "editImage": "Editar Imagem"
            },
            "success": "Usuário salvo com sucesso."
      },
      "companyModal": {
            "title": {
                  "add": "Adicionar empresa",
                  "edit": "Editar empresa"
            },
            "form": {
                  "name": "Nome",
                  "email": "Email",
                  "passwordDefault": "Senha",
                  "numberAttendants": "Usuários",
                  "numberConections": "Conexões"
            },
            "buttons": {
                  "okAdd": "Adicionar",
                  "okEdit": "Salvar",
                  "cancel": "Cancelar"
            },
            "success": "Empresa salvo com sucesso."
      },
      "scheduleModal": {
            "title": {
                  "add": "Novo Agendamento",
                  "edit": "Editar Agendamento",
                  "message": "Mensagem"
            },
            "form": {
                  "body": "Mensagem",
                  "contact": "Contato",
                  "sendAt": "Data de Agendamento",
                  "sentAt": "Data de Envio",
                  "assinar": "Enviar Assinatura",
                  "searchQuickMessages": "Digite para buscar respostas rápidas...",
                  "noQuickMessages": "Nenhuma resposta rápida encontrada",
                  "ticketConfig": "Configuração do Ticket",
                  "reminderOptional": "Lembrete (Opcional)",
                  "reminderDesc": "Defina uma data de lembrete. A mensagem será enviada no horário do lembrete em vez do horário original do agendamento.",
                  "reminderDate": "Data do Lembrete"
            },
            "buttons": {
                  "okAdd": "Adicionar",
                  "okEdit": "Salvar",
                  "cancel": "Cancelar",
                  "addSchedule": "Adicionar agendamento"
            },
            "success": "Agendamento salvo com sucesso."
      },
      "tagModal": {
            "title": {
                  "add": "Nova Tag",
                  "edit": "Editar Tag",
                  "addKanban": "Nova Lane",
                  "editKanban": "Editar Lane"
            },
            "form": {
                  "name": "Nome",
                  "color": "Cor",
                  "timeLane": "Tempo em minutos para redirecionar para lane",
                  "nextLaneId": "Lane",
                  "greetingMessageLane": "Mensagem de saudação da lane",
                  "mediaFiles": "Mídia",
                  "rollbackLaneId": "Voltar para Lane após retomar atendimento",
                  "clickToAttachMedia": "Clique para anexar mídia (Imagem, PDF, Áudio, Vídeo)",
                  "maxSizePerFile": "Tamanho máximo: 10MB por arquivo",
                  "required": "Obrigatório"
            },
            "buttons": {
                  "okAdd": "Adicionar",
                  "okEdit": "Salvar",
                  "cancel": "Cancelar"
            },
            "success": "Tag salva com sucesso.",
            "successKanban": "Lane salva com sucesso."
      },
      "fileModal": {
            "title": {
                  "add": "Adicionar lista de arquivos",
                  "edit": "Editar lista de arquivos"
            },
            "buttons": {
                  "okAdd": "Salvar",
                  "okEdit": "Editar",
                  "cancel": "Cancelar",
                  "fileOptions": "Adicionar arquivo"
            },
            "form": {
                  "name": "Nome da lista de arquivos",
                  "message": "Detalhes da lista",
                  "fileOptions": "Lista de arquivos",
                  "extraName": "Mensagem para enviar com arquivo",
                  "extraValue": "Valor da opção"
            },
            "success": "Lista de arquivos salva com sucesso!"
      },
      "chat": {
            "noTicketMessage": "Selecione um ticket para começar a conversar."
      },
      "uploads": {
            "titles": {
                  "titleUploadMsgDragDrop": "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
                  "titleFileList": "Lista de arquivo(s)"
            }
      },
      "chatInternal": {
            "new": "Criar grupo",
            "modal": {
                  "conversation": "Conversa",
                  "title": "Nome",
                  "filterUsers": "Selecione integrantes",
                  "cancel": "Fechar",
                  "save": "Salvar"
            },
            "modalDelete": {
                  "title": "Excluir Conversa",
                  "message": "Esta ação não pode ser revertida, confirmar?"
            }
      },
      "ticketsManager": {
            "questionCloseTicket": "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
            "yes": "SIM",
            "not": "NÃO",
            "buttons": {
                  "newTicket": "Novo",
                  "resolveAll": "Resolver Todos",
                  "close": "Fechar",
                  "new": "Novo"
            }
      },
      "ticketsQueueSelect": {
            "placeholder": "Filas"
      },
      "tickets": {
            "messageHidden": "Mensagem oculta",
            "inbox": {
                  "closedAllTickets": "Fechar todos os tickets?",
                  "closedAll": "Fechar Todos",
                  "newTicket": "Novo Ticket",
                  "yes": "SIM",
                  "no": "NÃO",
                  "open": "Abertos",
                  "resolverd": "Resolvidos",
                  "all": "Todos"
            },
            "toasts": {
                  "deleted": "O atendimento que você estava foi deletado."
            },
            "notification": {
                  "message": "Mensagem de",
                  "messageHidden": "Mensagem oculta"
            },
            "tabs": {
                  "open": {
                        "title": "Abertas"
                  },
                  "closed": {
                        "title": "Resolvidos"
                  },
                  "search": {
                        "title": "Busca"
                  }
            },
            "search": {
                  "placeholder": "Buscar atendimento e mensagens",
                  "filterConections": "Filtro por Conexão",
                  "filterConectionsOptions": {
                        "open": "Aberto",
                        "closed": "Fechado",
                        "pending": "Pendente"
                  },
                  "filterUsers": "Filtro por Usuarios",
                  "filterContacts": "Filtro por Contatos",
                  "ticketsPerPage": "Tickets por página"
            },
            "buttons": {
                  "showAll": "Todos",
                  "returnQueue": "Devolver a Fila",
                  "scredule": "Agendamento",
                  "deleteTicket": "Deletar Ticket"
            },
            "closedTicket": {
                  "closedMessage": "Fechar Ticket Com Mensagem de Despedida",
                  "closedNotMessage": "Fechar Ticket Sem Mensagem de Despedida"
            }
      },
      "transferTicketModal": {
            "title": "Transferir Ticket",
            "fieldLabel": "Digite para buscar usuários",
            "fieldQueueLabel": "Transferir para fila",
            "fieldQueuePlaceholder": "Selecione uma fila",
            "fieldWhatsapp": "Selecione um whatsapp",
            "noOptions": "Nenhum usuário encontrado com esse nome",
            "msgTransfer": "Observações - mensagem interna, não vai para o cliente",
            "buttons": {
                  "ok": "Transferir",
                  "cancel": "Cancelar"
            }
      },
      "ticketsList": {
            "called": "Chamado",
            "today": "Hoje",
            "missedCall": "Chamada de voz/vídeo perdida às",
            "pendingHeader": "Aguardando",
            "assignedHeader": "Atendendo",
            "groupingHeader": "Grupos",
            "noTicketsTitle": "Nada aqui!",
            "noTicketsMessage": "Nenhum atendimento encontrado com esse status ou termo pesquisado",
            "noQueue": "Sem Fila",
            "buttons": {
                  "accept": "Aceitar",
                  "cancel": "Cancelar",
                  "start": "iniciar",
                  "closed": "Fechar",
                  "reopen": "Reabrir",
                  "transfer": "Transferir",
                  "ignore": "Ignorar",
                  "exportAsPDF": "Exportar para PDF",
                  "kanbanActions": "Opções de Kanban"
            },
            "acceptModal": {
                  "title": "Aceitar Chat",
                  "queue": "Selecionar setor"
            }
      },
      "newTicketModal": {
            "title": "Criar Ticket",
            "fieldLabel": "Digite para pesquisar o contato",
            "add": "Adicionar",
            "buttons": {
                  "ok": "Salvar",
                  "cancel": "Cancelar"
            }
      },
      "SendContactModal": {
            "title": "Enviar contato",
            "fieldLabel": "Digite para pesquisar o contato",
            "add": "Adicionar",
            "buttons": {
                  "ok": "Enviar",
                  "cancel": "Cancelar"
            }
      },
      "mainDrawer": {
            "listItems": {
                  "dashboard": "Dashboard",
                  "connections": "Conexões",
                  "chatsTempoReal": "Painel",
                  "tickets": "Atendimentos",
                  "quickMessages": "Respostas rápidas",
                  "contacts": "Contatos",
                  "wallets": "Carteiras",
                  "queues": "Filas & Chatbot",
                  "tags": "Tags",
                  "administration": "ADMINISTRAÇÃO",
                  "companies": "Empresas",
                  "users": "Usuários",
                  "birthdaySettings": "Aniversariantes",
                  "settings": "Configurações",
                  "files": "Lista de arquivos",
                  "helps": "Ajuda",
                  "messagesAPI": "API",
                  "schedules": "Agendamentos",
                  "campaigns": "Campanhas",
                  "annoucements": "Informativos",
                  "chats": "Chat Interno",
                  "financeiro": "Financeiro",
                  "queueIntegration": "Integrações",
                  "version": "Versão",
                  "kanban": "Kanban",
                  "prompts": "Talk.Ai",
                  "allConnections": "Gerenciar conexões",
                  "reports": "Relatórios",
                  "management": "Gerência",
                  "callHistorical": "Histórico de Chamadas",
                  "automations": "Automações",
                  "aiAgents": "Agente de IA"
            },
            "appBar": {
                  "user": {
                        "profile": "Perfil",
                        "themeLight": "Tema Claro",
                        "themeDark": " Tema Escuro",
                        "logout": "Sair",
                        "message": "Olá",
                        "messageEnd": "seja bem-vindo(a) a",
                        "active": "Ativo até",
                        "goodMorning": "Oi,",
                        "myName": "Meu nome é",
                        "continuity": "e darei continuidade em seu atendimento.",
                        "virtualAssistant": "Assistente Virtual",
                        "token": "Token inválido, por favor entre em contato com o administrador da plataforma."
                  },
                  "message": {
                        "location": "Localização",
                        "contact": "Contato"
                  },
                  "notRegister": "Nenhum registro",
                  "refresh": "Atualizar"
            }
      },
      "languages": {
            "undefined": "Idioma",
            "pt-BR": "Português",
            "es": "Español",
            "en": "English",
            "tr": "Türkçe",
            "ar": "Árabe"
      },
      "messagesAPI": {
            "title": "API",
            "toSend": "ENVIAR",
            "textMessage": {
                  "number": "Número",
                  "body": "Mensagem",
                  "token": "Token cadastrado",
                  "userId": "ID do usuário/atendente",
                  "queueId": "ID da Fila"
            },
            "mediaMessage": {
                  "number": "Número",
                  "body": "Nome do arquivo",
                  "media": "Arquivo",
                  "token": "Token cadastrado"
            },
            "API": {
                  "title": "Documentação para envio de mensagens",
                  "methods": {
                        "title": "Métodos de Envío",
                        "messagesText": "Mensagens de Texto",
                        "messagesMidia": "Mensagens de Media"
                  },
                  "instructions": {
                        "title": "Instruções",
                        "comments": "Observações Importantes",
                        "comments1": "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
                        "comments2": "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
                        "codeCountry": "Código do País",
                        "code": "DDD",
                        "number": "Número"
                  },
                  "text": {
                        "title": "1. Mensagens de Texto",
                        "instructions": "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:"
                  },
                  "media": {
                        "title": "2. Mensagens de Media",
                        "instructions": "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:"
                  }
            }
      },
      "notifications": {
            "noTickets": "Nenhuma notificação.",
            "messageHidden": "Mensagem oculta",
            "newMessage": "Nova mensagem de"
      },
      "triggerFlowModal": {
            "title": "Disparar Fluxo",
            "description": "Selecione um fluxo para executar neste ticket. O ticket será alterado para status 'chatbot' durante a execução.",
            "selectFlow": "Escolha um fluxo",
            "selectedFlow": "Fluxo selecionado",
            "flowId": "ID do fluxo",
            "noFlows": "Nenhum fluxo ativo encontrado",
            "cancel": "Cancelar",
            "trigger": "Disparar Fluxo",
            "triggering": "Disparando...",
            "success": "Fluxo disparado com sucesso!",
            "error": "Erro ao disparar fluxo"
      },
      "quickMessages": {
            "title": "Respostas Rápidas",
            "searchPlaceholder": "Pesquisar...",
            "noAttachment": "Sem anexo",
            "confirmationModal": {
                  "deleteTitle": "Exclusão",
                  "deleteMessage": "Esta ação é irreversível! Deseja prosseguir?"
            },
            "selectMessage": "Selecionar Resposta Rápida",
            "hasMedia": "Com mídia",
            "global": "Global",
            "noResultsFound": "Nenhuma resposta rápida encontrada para sua busca",
            "noQuickMessages": "Nenhuma resposta rápida disponível",
            "buttons": {
                  "add": "Adicionar",
                  "attach": "Anexar Arquivo",
                  "cancel": "Cancelar",
                  "edit": "Editar"
            },
            "toasts": {
                  "success": "Atalho adicionado com sucesso!",
                  "deleted": "Atalho removido com sucesso!"
            },
            "dialog": {
                  "title": "Mensagem Rápida",
                  "shortcode": "Atalho",
                  "message": "Resposta",
                  "save": "Salvar",
                  "cancel": "Cancelar",
                  "geral": "Permitir editar",
                  "add": "Adicionar",
                  "edit": "Editar",
                  "general": "Geral",
                  "visao": "Permitir visão"
            },
            "table": {
                  "shortcode": "Atalho",
                  "message": "Mensagem",
                  "actions": "Ações",
                  "mediaName": "Nome do Arquivo",
                  "status": "Status"
            },
            "media": {
                  "attachMedia": "Anexar Mídia",
                  "editMedia": "Editar mídia",
                  "removeMedia": "Remover mídia",
                  "newFile": "Novo Arquivo",
                  "newAudioRecorded": "Novo áudio gravado",
                  "newAudio": "Novo Áudio",
                  "chooseMediaToReplace": "Escolha uma nova mídia para substituir:",
                  "chooseOptionToAttachMedia": "Escolha uma opção para anexar mídia:",
                  "attachFile": "Anexar Arquivo",
                  "recordAudio": "Gravar Áudio",
                  "cancelEdit": "Cancelar Edição"
            }
      },
      "contactLists": {
            "title": "Listas de Contatos",
            "table": {
                  "name": "Nome",
                  "contacts": "Contatos",
                  "actions": "Ações"
            },
            "buttons": {
                  "add": "Nova Lista"
            },
            "dialog": {
                  "name": "Nome",
                  "company": "Empresa",
                  "okEdit": "Editar",
                  "okAdd": "Adicionar",
                  "add": "Adicionar",
                  "edit": "Editar",
                  "cancel": "Cancelar"
            },
            "confirmationModal": {
                  "deleteTitle": "Excluir",
                  "deleteMessage": "Esta ação não pode ser revertida."
            },
            "toasts": {
                  "deleted": "Registro excluído"
            }
      },
      "contactListItems": {
            "title": "Contatos",
            "searchPlaceholder": "Pesquisa",
            "buttons": {
                  "add": "Novo",
                  "lists": "Listas",
                  "import": "Importar"
            },
            "dialog": {
                  "name": "Nome",
                  "number": "Número",
                  "whatsapp": "Whatsapp",
                  "email": "E-mail",
                  "okEdit": "Editar",
                  "okAdd": "Adicionar",
                  "add": "Adicionar",
                  "edit": "Editar",
                  "cancel": "Cancelar"
            },
            "table": {
                  "name": "Nome",
                  "number": "Número",
                  "whatsapp": "Whatsapp",
                  "email": "E-mail",
                  "actions": "Ações"
            },
            "confirmationModal": {
                  "deleteTitle": "Excluir",
                  "deleteMessage": "Esta ação não pode ser revertida.",
                  "importMessage": "Deseja importar os contatos desta planilha? ",
                  "importTitlte": "Importar"
            },
            "toasts": {
                  "deleted": "Registro excluído"
            }
      },
      "kanban": {
            "title": "Kanban",
            "searchPlaceholder": "Pesquisa",
            "subMenus": {
                  "list": "Painel",
                  "tags": "Lanes"
            },
            "sortBy": "Ordenar por",
            "ticketNumber": "Número do Ticket",
            "lastMessage": "Última Mensagem",
            "valueDesc": "Valor (maior para menor)",
            "startDate": "Data de início",
            "endDate": "Data de fim",
            "search": "Buscar",
            "addColumns": "+ Adicionar colunas",
            "itemsPerPage": "Itens/página"
      },
      "campaigns": {
            "title": "Campanhas",
            "searchPlaceholder": "Pesquisa",
            "subMenus": {
                  "list": "Listagem",
                  "listContacts": "Lista de contatos",
                  "settings": "Configurações"
            },
            "settings": {
                  "randomInterval": "Intervalo Randômico de Disparo",
                  "noBreak": "Sem Intervalo",
                  "intervalGapAfter": "Intervalo maior após",
                  "undefined": "Não definido",
                  "messages": "mensagens",
                  "laggerTriggerRange": "Intervalo de disparo maior",
                  "addVar": "Adicionar variável",
                  "save": "Salvar",
                  "close": "Fechar",
                  "add": "Adicionar",
                  "shortcut": "Atalho",
                  "content": "Conteúdo"
            },
            "buttons": {
                  "add": "Nova Campanha",
                  "contactLists": "Listas de Contatos"
            },
            "table": {
                  "name": "Nome",
                  "whatsapp": "Conexão",
                  "contactList": "Lista de Contatos",
                  "option": "Nenhuma",
                  "disabled": "Desabilitada",
                  "enabled": "Habilitada",
                  "status": "Status",
                  "scheduledAt": "Agendamento",
                  "completedAt": "Concluída",
                  "confirmation": "Confirmação",
                  "actions": "Ações",
                  "nextScheduledAt": "Próxima Execução"
            },
            "dialog": {
                  "new": "Nova Campanha",
                  "update": "Editar Campanha",
                  "readonly": "Apenas Visualização",
                  "help": "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
                  "form": {
                        "name": "Nome",
                        "message1": "Mensagem 1",
                        "message2": "Mensagem 2",
                        "message3": "Mensagem 3",
                        "message4": "Mensagem 4",
                        "message5": "Mensagem 5",
                        "confirmationMessage1": "Mensagem de Confirmação 1",
                        "confirmationMessage2": "Mensagem de Confirmação 2",
                        "confirmationMessage3": "Mensagem de Confirmação 3",
                        "confirmationMessage4": "Mensagem de Confirmação 4",
                        "confirmationMessage5": "Mensagem de Confirmação 5",
                        "messagePlaceholder": "Conteúdo da mensagem",
                        "whatsapp": "Conexão",
                        "status": "Status",
                        "scheduledAt": "Agendamento",
                        "confirmation": "Confirmação",
                        "contactList": "Lista de Contato",
                        "tagList": "Tags",
                        "statusTicket": "Status do Ticket",
                        "openTicketStatus": "Aberto",
                        "pendingTicketStatus": "Pendente",
                        "closedTicketStatus": "Fechado",
                        "enabledOpenTicket": "Habilitado",
                        "disabledOpenTicket": "Desabilitado",
                        "openTicket": "Abrir ticket",
                        "campaignMessage": "Mensagem da Campanha",
                        "attachMedia": "Anexar Mídia",
                        "contactListSectionTitle": "📋 Lista de Contatos da Campanha",
                        "contactListSectionDesc": "Selecione uma lista criada na aba \"📋 Listas de Contatos\". A lista define quem receberá as mensagens desta campanha.",
                        "filterByTagOptional": "Filtrar por Tag (opcional)",
                        "noTagFilter": "Sem filtro de tag",
                        "createOrSelectList": "+ Criar ou selecionar lista na aba Listas de Contatos"
                  },
                  "buttons": {
                        "add": "Adicionar",
                        "edit": "Atualizar",
                        "okadd": "Ok",
                        "cancel": "Cancelar Disparos",
                        "restart": "Reiniciar Disparos",
                        "close": "Fechar",
                        "attach": "Anexar Arquivo"
                  },
                  "tabs": {
                        "campaign": "Campanha",
                        "contactLists": "Listas de Contatos",
                        "settings": "Configurações"
                  },
                  "recurrence": {
                        "title": "Configuração de Recorrência",
                        "enable": "Habilitar recorrência"
                  },
                  "preview": {
                        "title": "Preview da Mensagem",
                        "subtitle": "Visualize como a mensagem aparecerá no WhatsApp",
                        "contact": "Contato",
                        "emptyMessage": "Digite uma mensagem para ver o preview aqui",
                        "availableVars": "Variáveis disponíveis:",
                        "attachedMedia": "Mídia anexada"
                  }
            },
            "confirmationModal": {
                  "deleteTitle": "Excluir",
                  "deleteMessage": "Esta ação não pode ser revertida."
            },
            "toasts": {
                  "success": "Operação realizada com sucesso",
                  "cancel": "Campanha cancelada",
                  "restart": "Campanha reiniciada",
                  "deleted": "Registro excluído"
            },
            "recurrenceRequired": "Tipo de recorrência é obrigatório",
            "intervalRequired": "Intervalo é obrigatório",
            "dayOfMonthRequired": "Dia do mês é obrigatório",
            "recurrenceTitle": "Recorrência",
            "recurring": "Recorrente",
            "single": "Única",
            "notCompleted": "Não concluída",
            "totalCount": "Total: {{count}} campanhas",
            "rowsPerPage": "Linhas por página:",
            "moreThan": "mais de",
            "status": {
                  "all": "Todos",
                  "INATIVA": "Inativa",
                  "PROGRAMADA": "Programada",
                  "EM_ANDAMENTO": "Em Andamento",
                  "CANCELADA": "Cancelada",
                  "FINALIZADA": "Finalizada"
            },
            "recurrence": {
                  "minutely": "Por Minuto",
                  "hourly": "Por Hora",
                  "daily": "Diário",
                  "weekly": "Semanal",
                  "biweekly": "Quinzenal",
                  "monthly": "Mensal",
                  "yearly": "Anual"
            },
            "vars": {
                  "name": "Nome",
                  "number": "Número",
                  "email": "Email",
                  "greeting": "Saudação",
                  "protocol": "Protocolo",
                  "firstName": "Primeiro Nome"
            }
      },
      "campaignReport": {
            "title": "Relatório de",
            "inactive": "Inativa",
            "scheduled": "Programada",
            "process": "Em Andamento",
            "cancelled": "Cancelada",
            "finished": "Finalizada",
            "campaign": "Campanha",
            "validContacts": "Contatos Válidos",
            "confirmationsRequested": "Confirmações Solicitadas",
            "confirmations": "Confirmações",
            "deliver": "Entregues",
            "connection": "Conexão",
            "contactLists": "Lista de Contatos",
            "schedule": "Agendamento",
            "conclusion": "Conclusão",
            "fetchError": "Erro ao buscar dados do relatório",
            "backButton": "Voltar"
      },
      "announcements": {
            "title": "Informativos",
            "searchPlaceholder": "Pesquisa",
            "active": "Ativo",
            "inactive": "Inativo",
            "buttons": {
                  "add": "Novo Informativo",
                  "contactLists": "Listas de Informativos"
            },
            "table": {
                  "priority": "Prioridade",
                  "title": "Title",
                  "text": "Texto",
                  "mediaName": "Arquivo",
                  "status": "Status",
                  "actions": "Ações"
            },
            "dialog": {
                  "edit": "Edição de Informativo",
                  "add": "Novo Informativo",
                  "update": "Editar Informativo",
                  "readonly": "Apenas Visualização",
                  "form": {
                        "priority": "Prioridade",
                        "title": "Title",
                        "text": "Texto",
                        "mediaPath": "Arquivo",
                        "status": "Status",
                        "high": "Alta",
                        "medium": "Média",
                        "low": "Baixa",
                        "active": "Ativo",
                        "inactive": "Inativo"
                  },
                  "buttons": {
                        "add": "Adicionar",
                        "edit": "Atualizar",
                        "okadd": "Ok",
                        "cancel": "Cancelar",
                        "close": "Fechar",
                        "attach": "Anexar Arquivo"
                  }
            },
            "confirmationModal": {
                  "deleteTitle": "Excluir",
                  "deleteMessage": "Esta ação não pode ser revertida."
            },
            "toasts": {
                  "success": "Operação realizada com sucesso",
                  "deleted": "Registro excluído"
            }
      },
      "campaignsConfig": {
            "title": "Configurações de Campanhas"
      },
      "queues": {
            "title": "Filas & Chatbot",
            "table": {
                  "name": "Nome",
                  "color": "Cor",
                  "greeting": "Mensagem de saudação",
                  "orderQueue": "Ordenação da fila (bot)",
                  "actions": "Ações",
                  "ID": "ID"
            },
            "buttons": {
                  "add": "Adicionar fila"
            },
            "toasts": {
                  "success": "Fila salva com sucesso",
                  "deleted": "Fila exclu[ida com sucesso"
            },
            "confirmationModal": {
                  "deleteTitle": "Excluir",
                  "deleteMessage": "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída."
            }
      },
      "queue": {
            "queueData": "Dados"
      },
      "queueSelect": {
            "inputLabel": "Filas",
            "inputLabelRO": "Filas somente leitura",
            "withoutQueue": "Sem fila"
      },
      "queueIntegration": {
            "title": "Integrações",
            "table": {
                  "id": "ID",
                  "type": "Tipo",
                  "name": "Nome",
                  "projectName": "Nome do Projeto",
                  "language": "Linguagem",
                  "lastUpdate": "Ultima atualização",
                  "actions": "Ações"
            },
            "buttons": {
                  "add": "Adicionar Projeto"
            },
            "searchPlaceholder": "Pesquisar...",
            "confirmationModal": {
                  "deleteTitle": "Excluir",
                  "deleteMessage": "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas"
            }
      },
      "users": {
            "title": "Usuários",
            "table": {
                  "status": "Status",
                  "name": "Nome",
                  "email": "Email",
                  "profile": "Perfil",
                  "startWork": "Inicio de trabalho",
                  "endWork": "Fim de trabalho",
                  "actions": "Ações",
                  "ID": "ID"
            },
            "buttons": {
                  "add": "Adicionar usuário",
                  "generateChats": "Gerar Chats Existentes"
            },
            "toasts": {
                  "deleted": "Usuário excluído com sucesso."
            },
            "confirmationModal": {
                  "deleteTitle": "Excluir",
                  "deleteMessage": "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila."
            }
      },
      "compaies": {
            "title": "Empresas",
            "table": {
                  "ID": "ID",
                  "status": "Ativo",
                  "name": "Nome",
                  "email": "Email",
                  "password": "Senha",
                  "phone": "Telefone",
                  "plan": "Plano",
                  "active": "Ativo",
                  "numberAttendants": "Atendentes",
                  "numberConections": "Conexões",
                  "value": "Valor",
                  "namePlan": "Nome Plano",
                  "numberQueues": "Filas",
                  "useCampaigns": "Campanhas",
                  "useExternalApi": "Rest API",
                  "useFacebook": "Facebook",
                  "useInstagram": "Instagram",
                  "useWhatsapp": "Whatsapp",
                  "useInternalChat": "Chat Interno",
                  "useSchedules": "Agendamento",
                  "createdAt": "Criada Em",
                  "dueDate": "Vencimento",
                  "lastLogin": "Ult. Login",
                  "folderSize": "Tamanho da pasta ",
                  "totalFiles": " Total de arquivos",
                  "lastUpdate": "Ultimo update",
                  "actions": "Ações",
                  "money": "R$",
                  "yes": "Sim",
                  "no": "Não",
                  "document": "CNPJ/CPF",
                  "recurrence": "Recorrência",
                  "monthly": "Mensal",
                  "bimonthly": "Bimestral",
                  "quarterly": "Trimestral",
                  "semester": "Semestral",
                  "yearly": "Anual",
                  "clear": "Limpar",
                  "delete": "Excluir",
                  "user": "Usuário",
                  "save": "Salvar",
                  "generateInvoice": "Gerar Fatura"
            },
            "buttons": {
                  "add": "Adicionar empresa"
            },
            "toasts": {
                  "deleted": "Empresa excluído com sucesso."
            },
            "confirmationModal": {
                  "deleteTitle": "Excluir",
                  "deleteMessage": "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila."
            },
            "editCompany": "Editar Empresa",
            "registerCompany": "Cadastrar Nova Empresa",
            "yes": "Sim",
            "no": "Não"
      },
      "plans": {
            "form": {
                  "name": "Nome",
                  "users": "Usuários",
                  "connections": "Conexões",
                  "campaigns": "Campanhas",
                  "schedules": "Agendamentos",
                  "enabled": "Habilitadas",
                  "disabled": "Desabilitadas",
                  "clear": "Cancelar",
                  "delete": "Excluir",
                  "save": "Salvar",
                  "yes": "Sim",
                  "no": "Não",
                  "money": "R$",
                  "public": "Público",
                  "trial": "Trial",
                  "trialDays": "Dias Trial"
            }
      },
      "helps": {
            "title": "Central de Ajuda",
            "settings": {
                  "codeVideo": "Código do Video",
                  "description": "Descrição",
                  "clear": "Limpar",
                  "delete": "Excluir",
                  "save": "Salvar"
            }
      },
      "schedules": {
            "title": "Agendamentos",
            "date": "Data",
            "time": "Hora",
            "event": "Evento",
            "allDay": "Dia Todo",
            "week": "Semana",
            "work_week": "Agendamentos",
            "day": "Dia",
            "month": "Mês",
            "previous": "Anterior",
            "next": "Próximo",
            "yesterday": "Ontem",
            "tomorrow": "Amanhã",
            "today": "Hoje",
            "agenda": "Agenda",
            "noEventsInRange": "Não há agendamentos no período.",
            "confirmationModal": {
                  "deleteTitle": "Você tem certeza que quer excluir este Agendamento?",
                  "deleteMessage": "Esta ação não pode ser revertida."
            },
            "table": {
                  "contact": "Contato",
                  "body": "Mensagem",
                  "sendAt": "Data de Agendamento",
                  "sentAt": "Data de Envio",
                  "status": "Status",
                  "actions": "Ações"
            },
            "buttons": {
                  "add": "Novo Agendamento"
            },
            "toasts": {
                  "deleted": "Agendamento excluído com sucesso."
            },
            "more": "mais"
      },
      "tags": {
            "title": "Tags",
            "addColumns": "+ ADICIONAR COLUNAS",
            "search": "BUSCAR",
            "seeTicket": "VER TICKET",
            "confirmationModal": {
                  "deleteTitle": "Você tem certeza que quer excluir esta Tag?",
                  "deleteMessage": "Esta ação não pode ser revertida."
            },
            "table": {
                  "id": "ID",
                  "name": "Nome",
                  "kanban": "Kanban",
                  "color": "Cor",
                  "tickets": "Registros Tags",
                  "contacts": "Contatos",
                  "actions": "Ações"
            },
            "buttons": {
                  "add": "Nova Tag"
            },
            "toasts": {
                  "deleted": "Tag excluído com sucesso."
            },
            "importLabels": "Importar Labels",
            "importing": "Importando..."
      },
      "tagsKanban": {
            "title": "Lanes",
            "laneDefault": "Em aberto",
            "backToKanban": "VOLTAR PARA O KANBAN",
            "confirmationModal": {
                  "deleteTitle": "Você tem certeza que quer excluir esta Lane?",
                  "deleteMessage": "Esta ação não pode ser revertida."
            },
            "table": {
                  "name": "Nome",
                  "color": "Cor",
                  "tickets": "Tickets",
                  "actions": "Ações"
            },
            "buttons": {
                  "add": "Nova Lane"
            },
            "toasts": {
                  "deleted": "Lane excluída com sucesso."
            }
      },
      "files": {
            "title": "Lista de arquivos",
            "table": {
                  "name": "Nome",
                  "contacts": "Contatos",
                  "actions": "Ação"
            },
            "toasts": {
                  "deleted": "Lista excluída com sucesso!",
                  "deletedAll": "Todas as listas foram excluídas com sucesso!"
            },
            "buttons": {
                  "add": "Adicionar",
                  "deleteAll": "Deletar Todos"
            },
            "confirmationModal": {
                  "deleteTitle": "Deletar",
                  "deleteAllTitle": "Deletar Todos",
                  "deleteMessage": "Tem certeza que deseja deletar esta lista?",
                  "deleteAllMessage": "Tem certeza que deseja deletar todas as listas?"
            }
      },
      "settings": {
            "success": "Configurações salvas com sucesso.",
            "title": "Configurações",
            "tabs": {
                  "options": "Opções",
                  "plans": "Planos",
                  "helps": "Ajuda",
                  "companies": "Empresas"
            },
            "settings": {
                  "userCreation": {
                        "name": "Criação de usuário",
                        "options": {
                              "enabled": "Ativado",
                              "disabled": "Desativado"
                        }
                  },
                  "tabs": {
                        "options": "Opções",
                        "schedules": "Horários",
                        "plans": "Planos",
                        "help": "Ajuda"
                  },
                  "options": {
                        "disabled": "Desabilitado",
                        "enabled": "Habilitado",
                        "updating": "Atualizando...",
                        "open": "Aberto",
                        "pending": "Pendente",
                        "creationCompanyUser": "Criação de Company/Usuário",
                        "evaluations": "Avaliações",
                        "officeScheduling": "Agendamento de Expediente",
                        "queueManagement": "Gerenciamento por Fila",
                        "companyManagement": "Gerenciamento por Empresa",
                        "connectionManagement": "Gerenciamento por Conexão",
                        "sendGreetingAccepted": "Enviar saudação ao aceitar o ticket",
                        "sendMsgTransfTicket": "Enviar mensagem transferência de setor/atendente",
                        "checkMsgIsGroup": "Ignorar Mensagens de Grupos",
                        "chatBotType": "Tipo do Bot",
                        "userRandom": "Escolher atendente aleatório",
                        "buttons": "Botões",
                        "acceptCallWhatsapp": "Informar que não aceita ligação no whatsapp?",
                        "sendSignMessage": "Permite atendente escolher ENVIAR Assinatura",
                        "sendGreetingMessageOneQueues": "Enviar saudação quando houver somente 1 fila",
                        "sendQueuePosition": "Enviar mensagem com a posição da fila",
                        "sendFarewellWaitingTicket": "Enviar mensagem de despedida no Aguardando",
                        "acceptAudioMessageContact": "Aceita receber audio de todos contatos?",
                        "enableLGPD": "Habilitar tratamento LGPD",
                        "requiredTag": "Tag obrigatoria para fechar ticket",
                        "closeTicketOnTransfer": "Fechar ticket ao transferir para outra fila",
                        "transferredTicketStatus": "Status do ticket ao transferir com usuário",
                        "DirectTicketsToWallets": "Mover automaticamente cliente para carteira",
                        "showNotificationPending": "Mostrar notificação para tickets pendentes",
                        "copyContactPrefix": "Sigla para Cópia de Contatos",
                        "copyContactPrefixPlaceholder": "Ex: COPIA_"
                  },
                  "customMessages": {
                        "sendQueuePositionMessage": "Mensagem de posição na fila",
                        "AcceptCallWhatsappMessage": "Mensagem para informar que não aceita ligações",
                        "greetingAcceptedMessage": "Mensagem de Saudação ao aceitar ticket",
                        "transferMessage": "Mensagem de transferência - ${queue.name} = fila destino"
                  },
                  "LGPD": {
                        "title": "LGPD",
                        "welcome": "Mensagem de boas vindas(LGPD)",
                        "linkLGPD": "Link da política de privacidade",
                        "obfuscateMessageDelete": "Ofuscar mensagem apagada",
                        "alwaysConsent": "Sempre solicitar consentimento",
                        "obfuscatePhoneUser": "Ofuscar número telefone para usuários",
                        "enabled": "Habilitado",
                        "disabled": "Desabilitado"
                  }
            }
      },
      "messagesList": {
            "header": {
                  "assignedTo": "Atribuído à:",
                  "dialogRatingTitle": "Deseja deixar uma avaliação de atendimento para o cliente?",
                  "dialogClosingTitle": "Finalizando o atendimento com o cliente!",
                  "dialogRatingCancel": "Resolver COM Mensagem de Despedida",
                  "dialogRatingSuccess": "Resolver e Enviar Avaliação",
                  "dialogRatingWithoutFarewellMsg": "Resolver SEM Mensagem de Despedida",
                  "ratingTitle": "Escolha um menu de avaliação",
                  "notMessage": "Nenhuma mensagem selecionada",
                  "amount": "Valor de prospecção",
                  "buttons": {
                        "return": "Retornar",
                        "resolve": "Resolver",
                        "reopen": "Reabrir",
                        "accept": "Aceitar",
                        "rating": "Enviar Avaliação",
                        "enableIntegration": "Habilitar integração",
                        "disableIntegration": "Desabilitar integração",
                        "logTicket": "Logs do Ticket",
                        "requiredTag": "Você deve atribuir uma tag antes de fechar o ticket.",
                        "greetingAcceptedMessage": "Você deve configurar uma mensagem de saudação ao aceitar o ticket."
                  }
            }
      },
      "messagesInput": {
            "placeholderPrivateMessage": "Digite uma mensagem ou aperte / para respostas rápidas",
            "placeholderOpen": "Digite uma mensagem ou aperte / para respostas rápidas",
            "placeholderClosed": "Reabra ou aceite esse ticket para enviar uma mensagem.",
            "signMessage": "Assinar",
            "privateMessage": "Mensagem Privada"
      },
      "contactDrawer": {
            "header": "Dados do contato",
            "buttons": {
                  "edit": "Editar contato",
                  "block": "Bloquear",
                  "unblock": "Desbloquear"
            },
            "extraInfo": "Outras informações"
      },
      "messageVariablesPicker": {
            "label": "Variavéis disponíveis",
            "vars": {
                  "contactFirstName": "Primeiro Nome",
                  "contactName": "Nome",
                  "user": "Atendente",
                  "greeting": "Saudação",
                  "protocolNumber": "Protocolo",
                  "date": "Data",
                  "hour": "Hora",
                  "ticket_id": "Nº do Chamado",
                  "queue": "Setor",
                  "connection": "Conexão",
                  "scheduledDate": "Data do Agendamento"
            }
      },
      "ticketOptionsMenu": {
            "schedule": "Agendamento",
            "delete": "Deletar",
            "transfer": "Transferir",
            "registerAppointment": "Observações do Contato",
            "resolveWithNoFarewell": "Finalizar sem despedida",
            "acceptAudioMessage": "Aceitar áudios do contato?",
            "appointmentsModal": {
                  "title": "Observações do Ticket",
                  "textarea": "Observação",
                  "placeholder": "Insira aqui a informação que deseja registrar"
            },
            "confirmationModal": {
                  "title": "Deletar o ticket do contato",
                  "titleFrom": "do contato ",
                  "message": "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas."
            },
            "buttons": {
                  "delete": "Excluir",
                  "cancel": "Cancelar"
            }
      },
      "confirmationModal": {
            "buttons": {
                  "confirm": "Ok",
                  "cancel": "Cancelar"
            }
      },
      "messageInput": {
            "tooltip": {
                  "signature": "Habilitar/Desabilitar Assinatura",
                  "privateMessage": "Habilitar/Desabilitar Mensagem Privada",
                  "meet": "Enviar link para videoconferencia",
                  "triggerFlow": "Disparar Fluxo"
            },
            "type": {
                  "imageVideo": "Fotos e vídeos",
                  "cam": "Câmera",
                  "contact": "Contato",
                  "meet": "Vídeo chamada",
                  "template": "Template Meta"
            }
      },
      "messageOptionsMenu": {
            "delete": "Deletar",
            "reply": "Responder",
            "edit": "Editar",
            "forward": "Encaminhar",
            "toForward": "Encaminhar",
            "talkTo": "Conversar Com",
            "confirmationModal": {
                  "title": "Apagar mensagem?",
                  "message": "Esta ação não pode ser revertida."
            }
      },
      "invoices": {
            "table": {
                  "invoices": "Faturas",
                  "details": "Detalhes",
                  "users": "Usuários",
                  "connections": "Conexões",
                  "queue": "Filas",
                  "value": "Valor",
                  "expirationDate": "Data Venc.",
                  "action": "Ação"
            }
      },
      "backendErrors": {
            "ERR_NO_OTHER_WHATSAPP": "Deve haver pelo menos um WhatsApp padrão.",
            "ERR_NO_DEF_WAPP_FOUND": "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
            "ERR_WAPP_NOT_INITIALIZED": "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
            "ERR_WAPP_CHECK_CONTACT": "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
            "ERR_WAPP_INVALID_CONTACT": "Este não é um número de Whatsapp válido.",
            "ERR_WAPP_DOWNLOAD_MEDIA": "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
            "ERR_INVALID_CREDENTIALS": "Dados de login errados.",
            "ERR_USER_NOT_REGISTERED": "Você não está cadastrado.",
            "ERR_OUT_OF_HOURS": "Fora do Horário de Expediente!",
            "ERR_SENDING_WAPP_MSG": "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
            "ERR_DELETE_WAPP_MSG": "Não foi possível excluir a mensagem do WhatsApp.",
            "ERR_OTHER_OPEN_TICKET": "Já existe um tíquete aberto para este contato.",
            "ERR_SESSION_EXPIRED": "Sessão expirada. Por favor entre.",
            "ERR_USER_CREATION_DISABLED": "A criação do usuário foi desabilitada pelo administrador.",
            "ERR_NO_PERMISSION": "Você não tem permissão para acessar este recurso.",
            "ERR_DUPLICATED_CONTACT": "Já existe um contato com este número.",
            "ERR_NO_SETTING_FOUND": "Nenhuma configuração encontrada com este ID.",
            "ERR_NO_CONTACT_FOUND": "Nenhum contato encontrado com este ID.",
            "ERR_NO_TICKET_FOUND": "Nenhum tíquete encontrado com este ID.",
            "ERR_NO_USER_FOUND": "Nenhum usuário encontrado com este ID.",
            "ERR_NO_WAPP_FOUND": "Nenhum WhatsApp encontrado com este ID.",
            "ERR_CREATING_MESSAGE": "Erro ao criar mensagem no banco de dados.",
            "ERR_CREATING_TICKET": "Erro ao criar tíquete no banco de dados.",
            "ERR_FETCH_WAPP_MSG": "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
            "ERR_QUEUE_COLOR_ALREADY_EXISTS": "Esta cor já está em uso, escolha outra.",
            "ERR_WAPP_GREETING_REQUIRED": "A mensagem de saudação é obrigatório quando há mais de uma fila."
      },
      "messagesAPIInstructions": {
            "endpoint": "Endpoint:",
            "method": "Método:",
            "post": "POST",
            "headers": "Headers:",
            "headerAuthorization": "Authorization Bearer (token registrado) e Content-Type (application/json)",
            "body": "Body:",
            "fieldNumber": "\"number\": \"558599999999\"",
            "fieldBody": "\"body\": \"Mensagem\"",
            "fieldUserId": "\"userId\": ID do usuário ou \"\"",
            "fieldQueueId": "\"queueId\": ID da Fila ou \"\"",
            "fieldSendSignature": "\"sendSignature\": Assinar mensagem - true/false",
            "fieldCloseTicket": "\"closeTicket\": Encerrar o ticket - true/false",
            "singMessage": "Assinar mensagem - true/false",
            "closeTicket": "Encerrar o ticket - true/false",
            "testSend": "Teste de envio"
      },
      "recurrenceSection": {
            "title": "Recorrência",
            "description": "Você pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma única vez, não altere nada nesta seção.",
            "labelInterval": "Intervalo",
            "intervalFilterValue": "Valor do Intervalo",
            "sendAsManyTimes": " Enviar quantas vezes",
            "shipNormallyOnNonbusinessDays": " Enviar em dias não úteis",
            "sendOneBusinessDayBefore": "Enviar um dia útil antes",
            "sendOneBusinessDayLater": "Enviar um dia útil depois",
            "options": {
                  "days": "Dias",
                  "weeks": "Semanas",
                  "months": "Meses",
                  "minutes": "Minutos"
            }
      },
      "servicePanel": {
            "allowRealTime": "Painel de Atendimentos-"
      },
      "financial": {
            "invoices": "Faturas",
            "details": "Detalhes",
            "users": "Usuários",
            "connections": "Conexões",
            "queues": "Filas",
            "value": "Valor",
            "expirationDate": "Data Venc.",
            "status": "Status",
            "action": "Ação"
      },
      "statusFilter": {
            "statusFilter": "Filtro por Status"
      },
      "momentsUser": {
            "services": "Atendimentos:",
            "pending": "Pendentes",
            "noqueue": "SEM FILA"
      },
      "campaignsPhrase": {
            "campaignsFlow": "Fluxo de Campanhas",
            "campaigns": "Campanhas",
            "name": "Nome",
            "status": " Status",
            "newCampaignWithFlowByPhrase": "Nova campanha com fluxo por frase",
            "editCampaignWithFlowByPhrase": "Editar campanha com fluxo por frase",
            "phraseTriggerName": "Nome do disparo por frase",
            "chooseAStream": " Escolha um fluxo",
            "whichPhraseTriggersTheFlow": " Qual frase dispara o fluxo?",
            "selectAConnection": " Selecione uma Conexão",
            "cancel": "CANCELAR",
            "createCampaign": "CRIAR CAMPANHA ",
            "saveCampaign": "Salvar Campanha",
            "title": "Campanhas de Fluxo",
            "newCampaign": "Nova Campanha",
            "noCampaigns": "Nenhuma campanha encontrada",
            "clickNewCampaign": "Clique em \"Nova Campanha\" para criar sua primeira campanha de fluxo",
            "table": {
                  "name": "Nome",
                  "connections": "Conexões",
                  "status": "Status"
            },
            "dialog": {
                  "campaignName": "Nome da campanha",
                  "nameRequired": "Nome é obrigatório",
                  "selectFlow": "Selecione um fluxo",
                  "flowRequired": "Fluxo é obrigatório",
                  "whatsappConnections": "Conexões WhatsApp",
                  "filterByContactTag": "Filtrar por Tag do Contato",
                  "optional": "opcional",
                  "tagFilterDesc": "Se selecionada(s), o fluxo só será disparado para contatos que possuam pelo menos uma dessas tags no atendimento.",
                  "tagsOptional": "Tags (opcional)",
                  "keywordsTitle": "Palavras-chave que disparam o fluxo",
                  "keywordsDesc": "🔀 Lógica OU: O fluxo será disparado se o contato enviar qualquer uma das palavras/frases abaixo. Exata: mensagem idêntica. | Parcial: palavra contida em qualquer parte da mensagem.",
                  "wordPhraseIndex": "Palavra/frase {{index}}",
                  "type": "Tipo",
                  "exact": "Exata",
                  "partial": "Parcial",
                  "addAnotherKeyword": "+ ADICIONAR OUTRA PALAVRA/FRASE (OU)",
                  "active": "Ativa",
                  "inactive": "Inativa",
                  "saving": "Salvando...",
                  "update": "Atualizar",
                  "create": "Criar"
            }
      },
      "whatsappModalRel": {
            "form": {
                  "isOficial": "Relatório do Atendimento",
                  "ticketId": "ID do Ticket",
                  "client": "Cliente",
                  "number": "Número",
                  "agent": "Atendente",
                  "date": "Data",
                  "lastMessage": "Última Mensagem",
                  "fullReport": "O relatório completo foi anexado acima",
                  "resolveAndTriggerIntegration": "Resolver e Disparar Integração",
                  "elementNotFoundForExport": "Elemento não encontrado para exportar.",
                  "reportFilename": "relatório_atendimento"
            }
      },
      "chatList": {
            "noMessages": "Nenhuma mensagem",
            "admin": "Administrador",
            "member": "Membro",
            "searchChat": "Procurar chat...",
            "createNewChat": "Criar novo chat",
            "searchUser": "Procurar usuário...",
            "noUserFound": "Nenhum usuário encontrado",
            "noUserAvailable": "Nenhum usuário disponível",
            "cancel": "Cancelar",
            "details": "Detalhes",
            "deleteChat": "Excluir Conversa",
            "deleteChatConfirm": "Esta ação não pode ser revertida, confirmar?",
            "detailsTitle": "Detalhes",
            "edit": "Editar",
            "delete": "Excluir",
            "now": "agora",
            "minutesAgo": "{{count}}m atrás",
            "hoursAgo": "{{count}}h atrás"
      },
      "chatMessages": {
            "deleted": "Esta mensagem foi apagada",
            "deletedAdmin": "Mensagem apagada - visível apenas para administradores",
            "reply": "Responder",
            "edit": "Editar",
            "delete": "Excluir",
            "forward": "Encaminhar",
            "editMessage": "Editar Mensagem",
            "save": "Salvar",
            "cancel": "Cancelar",
            "deleteMessage": "Deletar Mensagem",
            "deleteMessageConfirm": "Tem certeza que deseja deletar esta mensagem?",
            "forwardMessage": "Encaminhar Mensagem",
            "selectChat": "Selecione o chat",
            "doubleClickToReply": "Clique duas vezes para responder",
            "edited": "(editada)",
            "forwarded": "(encaminhada)",
            "typeMessage": "Digite uma mensagem...",
            "send": "Enviar",
            "noMessages": "Nenhuma mensagem",
            "loading": "Carregando...",
            "replyingTo": "Respondendo a",
            "clickToGoToOriginal": "Clique para ir até a mensagem original"
      },
      "chatPopover": {
            "reply": "Responder",
            "edit": "Editar",
            "delete": "Excluir",
            "forward": "Encaminhar",
            "cancel": "Cancelar",
            "confirmDelete": "Confirmar Exclusão",
            "confirm": "Confirmar",
            "deleteMessage": "Tem certeza que deseja excluir esta mensagem?",
            "editMessage": "Editar Mensagem",
            "save": "Salvar",
            "forwardMessage": "Encaminhar Mensagem",
            "selectChat": "Selecione o chat",
            "noChats": "Nenhum chat disponível"
      },
      "chatIndex": {
            "chats": "Chats",
            "groups": "Grupos",
            "new": "Novo",
            "messages": "Mensagens",
            "search": "Buscar...",
            "noChats": "Nenhum chat encontrado",
            "noGroups": "Nenhum grupo encontrado",
            "noMessages": "Nenhuma mensagem",
            "loading": "Carregando...",
            "error": "Erro ao carregar dados",
            "addGroupPhoto": "Adicionar Foto do Grupo",
            "changeGroupPhoto": "Alterar Foto do Grupo",
            "groupName": "Nome do Grupo",
            "groupDescription": "Descrição do Grupo",
            "save": "Salvar",
            "cancel": "Cancelar",
            "createGroup": "Criar Grupo",
            "editGroup": "Editar Grupo",
            "deleteGroup": "Deletar Grupo",
            "deleteGroupConfirm": "Tem certeza que deseja deletar este grupo?",
            "edit": "Editar",
            "delete": "Excluir",
            "details": "Detalhes",
            "groupDetails": "Detalhes do Grupo",
            "title": "Título",
            "description": "Descrição",
            "modal": {
                  "title": "Criar Grupo",
                  "editTitle": "Editar Grupo",
                  "save": "Salvar",
                  "cancel": "Cancelar",
                  "addGroupPhoto": "Adicionar Foto do Grupo",
                  "changeGroupPhoto": "Alterar Foto do Grupo",
                  "titleField": "Título",
                  "descriptionField": "Descrição",
                  "descriptionPlaceholder": "Descrição do grupo"
            }
      },
      "whitelabel": {
            "primaryColorLight": "Cor Primária (Tema Claro)",
            "primaryColorDark": "Cor Primária (Tema Escuro)",
            "appName": "Nome da Aplicação",
            "logoLight": "Logo Menu Vertical (Tema Claro)",
            "logoDark": "Logo Menu Vertical (Tema Escuro)",
            "favicon": "Favicon",
            "logoSplash": "Logo Splash Screen (Carregamento)",
            "backgroundImage": "Imagem de Fundo (Aplicação)",
            "logoHorizontalMenu": "Logo (Menu Horizontal)",
            "logoHorizontalMenuLight": "Logo Menu Horizontal (Tema Claro)",
            "logoHorizontalMenuDark": "Logo Menu Horizontal (Tema Escuro)",
            "themeLight": "☀️ Tema Claro",
            "themeDark": "🌙 Tema Escuro",
            "backgroundLight": "Imagem de Fundo (Tema Claro)",
            "backgroundDark": "Imagem de Fundo (Tema Escuro)",
            "preview": "Visualizar",
            "delete": "Excluir",
            "upload": "Enviar",
            "availableLanguages": "Idiomas Disponíveis",
            "atLeastOneLanguage": "Pelo menos um idioma deve estar habilitado",
            "sections": {
                  "general": "Configurações Gerais",
                  "generalDescription": "Configure o nome e informações básicas da aplicação",
                  "colors": "Cores e Temas",
                  "colorsDescription": "Personalize as cores primárias para temas claro e escuro",
                  "logos": "Logos e Imagens",
                  "logosDescription": "Carregue os logos e imagens de fundo da aplicação",
                  "languages": "Idiomas Disponíveis",
                  "languagesDescription": "Selecione quais idiomas estarão disponíveis no sistema"
            }
      },
      "webhookModal": {
            "toasts": {
                  "update": "Fluxo atualizado com sucesso!",
                  "saveSuccess": "Fluxo criado com sucesso!"
            }
      },
      "aiAgentPage": {
            "title": "Agente de IA",
            "addAgent": "Adicionar Agente",
            "deleteConfirmTitle": "Excluir agente",
            "deleteConfirmBody": "Esta ação não pode ser desfeita.",
            "deleteSuccess": "Agente removido com sucesso",
            "deleteErrorInvalid": "Erro: ID do agente inválido. Recarregue a página e tente novamente.",
            "metrics": {
                  "totalTokens": "Total de Tokens",
                  "inputTokens": "Tokens de Entrada",
                  "outputTokens": "Tokens de Saída",
                  "estimatedCost": "Custo Estimado USD"
            },
            "table": {
                  "name": "Nome",
                  "sector": "Setor/Fila",
                  "model": "Modelo",
                  "maxTokens": "Máx. Tokens",
                  "tokensUsed": "Tokens Usados",
                  "status": "Status",
                  "actions": "Ações"
            },
            "status": {
                  "active": "Ativo",
                  "inactive": "Inativo"
            },
            "tooltips": {
                  "edit": "Editar",
                  "delete": "Excluir"
            }
      },
      "aiAgentModal": {
            "editTitle": "Editar Agente de IA",
            "createTitle": "Criar Agente de IA",
            "tabs": {
                  "basic": "Básico",
                  "behavior": "Comportamento",
                  "advanced": "Avançado",
                  "knowledge": "Conhecimento",
                  "test": "Testar",
                  "reply": "Responder"
            },
            "toasts": {
                  "nameRequired": "Informe o nome do agente",
                  "apiKeyRequired": "Informe a API Key",
                  "saved": "Agente salvo com sucesso!",
                  "itemUpdated": "Item atualizado",
                  "itemAdded": "Item adicionado",
                  "titleRequired": "Informe o título",
                  "contentRequired": "Informe o conteúdo",
                  "fileRequired": "Selecione um arquivo",
                  "saveFirst": "Salve o agente primeiro para adicionar itens de conhecimento"
            },
            "functions": {
                  "general": "Geral",
                  "generalSub": "Assistente multiuso",
                  "sales": "Vendas",
                  "salesSub": "Focado em conversão",
                  "support": "Suporte",
                  "supportSub": "Atendimento técnico",
                  "scheduling": "Agendamento",
                  "schedulingSub": "Marcação de horários",
                  "financial": "Financeiro",
                  "financialSub": "Cobranças e pagamentos"
            },
            "tones": {
                  "friendly": "Amigável 😊",
                  "professional": "Profissional 💼",
                  "formal": "Formal 🎩",
                  "casual": "Casual 😎",
                  "empathetic": "Empático 🥹",
                  "technical": "Técnico 🔧"
            },
            "models": {
                  "recommended": "Recomendado",
                  "smarter": "Mais inteligente",
                  "fast": "Rápido",
                  "highPerf": "Alta performance",
                  "ultraFast": "Ultra rápido",
                  "reasoning": "Raciocínio avançado"
            },
            "basic": {
                  "agentName": "Nome do Agente",
                  "functionSection": "Função",
                  "voiceToneSection": "Tom de Voz",
                  "aiModelSection": "Modelo de IA",
                  "apiKeyLabel": "API Key OpenAI",
                  "responseLanguages": "Idiomas de Resposta",
                  "personality": "Personalidade (instrução ao agente)",
                  "personalityPlaceholder": "Ex: Você é um assistente prestativo que responde de forma clara...",
                  "activeAgent": "Agente Ativo"
            },
            "behavior": {
                  "initialMessage": "Mensagem Inicial (opcional)",
                  "initialMsgPlaceholder": "Olá! Sou o assistente virtual. Como posso ajudar?",
                  "responseRules": "Regras de Resposta",
                  "responseRulesPlaceholder": "Liste as regras que o agente deve seguir ao responder...",
                  "allowTransfer": "Permitir transferência para atendente humano",
                  "transferKeywords": "Palavras-chave para transferência",
                  "transferKwPlaceholder": "atendente, humano, ajuda real (separar por vírgula)",
                  "transferMessage": "Mensagem ao transferir",
                  "transferMsgPlaceholder": "Vou transferir você para um atendente humano.",
                  "responsibleAgent": "Atendente Responsável",
                  "assignMode": "Modo de Atribuição",
                  "randomAgent": "🎲 Atendente Aleatório em Sequência",
                  "specificAgent": "👤 Atendente(s) Específico(s)",
                  "noAgentFound": "Nenhum atendente encontrado.",
                  "agentsSelected": "atendente(s) selecionado(s)",
                  "sectorQueue": "Setor / Fila",
                  "noQueue": "Nenhuma (global)",
                  "returnMenuEnabled": "Permitir retorno ao menu inicial",
                  "returnMenuKeywords": "Palavras-chave para voltar ao menu",
                  "returnMenuKwPlaceholder": "menu, menu inicial, voltar ao menu, voltar para o menu (separar por vírgula)",
                  "returnMenuMessage": "Mensagem ao retornar ao menu (opcional)",
                  "returnMenuMsgPlaceholder": "Aguarde, vou te enviar o menu novamente...",
                  "closeTicketEnabled": "Permitir encerramento por palavras-chave",
                  "closeTicketKeywords": "Palavras-chave para encerrar atendimento",
                  "closeTicketKwPlaceholder": "sair, encerrar, finalizar, tchau... (separar por vírgula)",
                  "closeTicketMessage": "Mensagem de despedida (opcional)",
                  "closeTicketMsgPlaceholder": "Obrigado pelo contato! Até a próxima!"
            },
            "advanced": {
                  "responseDelay": "Delay de Resposta (segundos)",
                  "charLimit": "Limite de Caracteres por Resposta",
                  "humanizeChat": "Humanizar conversa (simular digitação)",
                  "audioFeatures": "Recursos de Áudio",
                  "temperature": "Temperatura",
                  "maxTokens": "Max Tokens",
                  "maxMessages": "Max Mensagens",
                  "learningMode": "Modo de Aprendizado",
                  "learningBoth": "🌟 Ambos (Empresa + Cliente)",
                  "learningGeneral": "🏢 Apenas Geral da Empresa",
                  "learningContact": "👤 Apenas Histórico do Cliente",
                  "learningHelp": "💡 Ao finalizar cada atendimento, a IA extrai regras/fatos da empresa e preferências do cliente para consultar em conversas futuras."
            },
            "knowledge": {
                  "saveFirst": "Salve o agente primeiro para adicionar itens de conhecimento.",
                  "saveAgentNow": "Salvar Agente Agora",
                  "baseTitle": "Base de Conhecimento",
                  "item": "item",
                  "items": "itens",
                  "add": "Adicionar",
                  "type": "Tipo",
                  "title": "Título",
                  "content": "Conteúdo",
                  "contentPlaceholder": "Cole aqui o texto de conhecimento...",
                  "clickToSelect": "Clique para selecionar o arquivo",
                  "fileTypes": "PDF, Word, Excel, ZIP, PNG, JPG...",
                  "save": "Salvar",
                  "cancel": "Cancelar",
                  "noItems": "Nenhum item de conhecimento. Clique em 'Adicionar' para inserir.",
                  "edit": "Editar",
                  "delete": "Excluir"
            },
            "test": {
                  "modelForTest": "Modelo para teste",
                  "sendMsg": "Envie uma mensagem para testar o agente",
                  "waiting": "Aguardando resposta...",
                  "inputPlaceholder": "Digite uma mensagem de teste...",
                  "fillApiKey": "Preencha a API Key na aba Básico para testar."
            },
            "reply": {
                  "description": "Defina para quais contatos este agente irá responder automaticamente.",
                  "replyMode": "Modo de Resposta",
                  "allLabel": "Todos",
                  "allSub": "Responde a todos os contatos",
                  "contactsLabel": "Contatos selecionados",
                  "contactsSub": "Apenas contatos específicos",
                  "tagsLabel": "Por tag",
                  "tagsSub": "Contatos com tag específica",
                  "contactsTitle": "Contatos",
                  "selected": "selecionado(s)",
                  "clearSelection": "Limpar seleção",
                  "searchPlaceholder": "Buscar contato por nome ou número...",
                  "noContacts": "Nenhum contato encontrado.",
                  "tagsTitle": "Tags",
                  "noTags": "Nenhuma tag cadastrada.",
                  "createTagsHint": "Crie tags em Contatos → Tags.",
                  "tagFilterMsgSingle": "✓ O agente responderá apenas contatos com a tag selecionada.",
                  "tagFilterMsgMulti": "✓ O agente responderá apenas contatos com uma das {{count}} tags selecionadas.",
                  "allModeMsg": "🌐 Todos os contatos — o agente responderá qualquer contato que iniciar uma conversa."
            },
            "actions": {
                  "cancel": "Cancelar",
                  "save": "Salvar Agente",
                  "saving": "Salvando..."
            },
            "memoryAndLearningTitle": "🧠 MEMÓRIA & AUTO-APRENDIZADO",
            "enableAutoMemory": "Permitir que a IA aprenda automaticamente com as conversas"
      },
      "birthdaySettings": {
            "title": "Configurações de Aniversário",
            "subtitle": "Gerencie notificações e mensagens automáticas de aniversário para usuários e contatos",
            "toasts": {
                  "fetchError": "Erro ao carregar configurações de aniversário",
                  "saveSuccess": "Configurações de aniversário salvas com sucesso! 🎉",
                  "saveError": "Erro ao salvar configurações",
                  "promptContactId": "Digite o ID de um contato para teste:",
                  "testSent": "Mensagem de teste enviada! 📱",
                  "testError": "Erro ao enviar mensagem de teste"
            },
            "userSection": {
                  "title": "Aniversários de Usuários",
                  "enableNotifications": "Habilitar notificações de aniversário de usuários",
                  "enableNotificationsHelp": "Quando habilitado, será exibido modal de parabéns e criado informativo automático",
                  "createAnnouncement": "Criar informativo automático para aniversários de usuários",
                  "createAnnouncementHelp": "Cria um informativo automático que é exibido para todos os usuários da empresa",
                  "messageLabel": "Mensagem de aniversário para usuários",
                  "messageHelp": "Use {nome} para incluir o nome do usuário"
            },
            "contactSection": {
                  "title": "Aniversários de Contatos",
                  "enableAutoSend": "Habilitar envio automático de mensagens de aniversário para contatos",
                  "enableAutoSendHelp": "Envia automaticamente mensagem de parabéns via WhatsApp para contatos aniversariantes",
                  "messageLabel": "Mensagem de aniversário para contatos",
                  "messageHelp": "Use {nome} para incluir o nome do contato e {idade} para a idade"
            },
            "generalSection": {
                  "title": "Configurações Gerais",
                  "sendTimeLabel": "Horário de envio das mensagens",
                  "sendTimeHelp": "Horário em que as mensagens automáticas serão enviadas",
                  "whatsappConnection": "Conexão WhatsApp para Envio",
                  "selectConnection": "Selecione uma conexão",
                  "whatsappConnectionHelp": "Conexão WhatsApp que será usada para enviar mensagens de aniversário",
                  "createInternalAnnouncement": "Criar informativo interno para aniversários de usuários",
                  "createInternalAnnouncementHelp": "Cria um informativo interno quando um usuário faz aniversário",
                  "varsInfoTitle": "💡 Variáveis disponíveis nas mensagens:",
                  "varNomeHelp": "• {nome} - Nome da pessoa",
                  "varIdadeHelp": "• {idade} - Idade da pessoa (apenas para contatos)"
            },
            "saveButton": "Salvar Configurações",
            "savingButton": "Salvando..."
      },
      "floupDashboard": {
            "title": "Follow UP por Etapas",
            "refresh": "Atualizar",
            "followUp": "Follow UP",
            "inactive": "(Inativo)",
            "steps": "Etapas",
            "contacts": "Contatos",
            "search": "Buscar",
            "channel": "Canal",
            "all": "Todos",
            "noMessage": "Sem mensagem",
            "noContactsInStep": "Nenhum contato nesta etapa",
            "selectFloup": "Selecione um Floup para visualizar as etapas",
            "noDataFound": "Nenhum dado encontrado para este Floup",
            "noStepsFound": "Nenhuma etapa encontrada"
      },
      "templateManager": {
            "title": "Gerenciamento de Templates",
            "connection": "Conexão",
            "searchPlaceholder": "Buscar...",
            "syncTooltip": "Sincronizar com Meta",
            "createTemplate": "Criar Template",
            "emptyConnection": "Nenhuma conexão de API Oficial encontrada. Adicione uma conexão oficial para gerenciar templates.",
            "table": {
                  "name": "Nome",
                  "category": "Categoria",
                  "language": "Idioma",
                  "status": "Status",
                  "actions": "Ações"
            },
            "status": {
                  "approved": "Aprovado",
                  "pending": "Pendente",
                  "rejected": "Rejeitado"
            },
            "categories": {
                  "marketing": "Marketing",
                  "utility": "Utilidade",
                  "authentication": "Autenticação"
            },
            "buttons": {
                  "close": "Fechar",
                  "cancel": "Cancelar",
                  "sendForApproval": "Enviar para Aprovação"
            },
            "createModal": {
                  "title": "Criar Novo Template",
                  "templateName": "Nome do Template",
                  "nameHelperText": "Apenas letras minúsculas, números e _",
                  "headerOptional": "Cabeçalho (opcional)",
                  "headerHelperText": "Texto exibido no topo do template",
                  "bodyMessage": "Corpo da Mensagem",
                  "bodyHelperText": "Use {{1}}, {{2}}, etc. para variáveis. Ex: Olá {{1}}, seu pedido {{2}} está pronto!",
                  "footerOptional": "Rodapé (opcional)",
                  "footerHelperText": "Texto pequeno no final do template",
                  "buttonsOptional": "Botões (opcional - máx 3)",
                  "addQuickReply": "+ Resposta Rápida",
                  "addLink": "+ Link",
                  "addPhone": "+ Telefone",
                  "quickReplyChip": "Resp. Rápida",
                  "linkChip": "Link",
                  "phoneChip": "Telefone",
                  "text": "Texto",
                  "phone": "Telefone",
                  "preview": "Pré-visualização",
                  "button": "Botão"
            },
            "viewModal": {
                  "title": "Detalhes do Template",
                  "components": "Componentes"
            },
            "deleteModal": {
                  "title": "Excluir template \"{{name}}\"?",
                  "confirmText": "Esta ação irá excluir o template na Meta e localmente. Deseja continuar?"
            }
      },
      "flowBuilder": {
            "title": "Fluxos de Conversa ({{count}})",
            "searchPlaceholder": "Buscar fluxos...",
            "importZip": "Importar (.zip)",
            "newFlow": "NOVO FLUXO",
            "editorTitle": "Editor de Fluxos",
            "addNodes": "Adicionar Nós",
            "categories": {
                  "basics": "Básicos",
                  "content": "Conteúdo",
                  "interaction": "Interação",
                  "logic": "Lógica",
                  "system": "Sistema",
                  "integrations": "Integrações"
            },
            "nodes": {
                  "start": "Início",
                  "startDesc": "Ponto inicial do fluxo",
                  "content": "Conteúdo",
                  "contentDesc": "Enviar texto, imagem, áudio ou vídeo",
                  "text": "Texto",
                  "textDesc": "Mensagem de texto simples",
                  "menu": "Menu",
                  "menuDesc": "Menu numérico de opções",
                  "interactiveMenu": "Msg Interativa API",
                  "interactiveMenuDesc": "Botões e listas (Baileys)",
                  "input": "Input",
                  "inputDesc": "Coletar entrada do usuário",
                  "interval": "Intervalo",
                  "intervalDesc": "Pausar execução por tempo",
                  "randomizer": "Randomizador",
                  "randomizerDesc": "Escolha aleatória de caminhos",
                  "ifElse": "Se/Senão (If/Else)",
                  "ifElseDesc": "Bifurcar fluxo com base em condição",
                  "queues": "Filas",
                  "queuesDesc": "Gerenciar filas de atendimento",
                  "tags": "Tags",
                  "tagsDesc": "Adicionar tags ao contato",
                  "removeTag": "Remover Tag",
                  "removeTagDesc": "Remover tags do contato",
                  "switchFlow": "Trocar Flow",
                  "switchFlowDesc": "Direcionar para outro fluxo",
                  "attendant": "Atendente",
                  "attendantDesc": "Transferir para atendente",
                  "transferConnection": "Trocar Conexao",
                  "transferConnectionDesc": "Transferir para outra conexao",
                  "closeTicket": "Encerrar Atendimento",
                  "closeTicketDesc": "Finalizar e fechar o ticket",
                  "httpRequest": "HTTP Request",
                  "httpRequestDesc": "Requisição HTTP externa",
                  "variable": "Variável",
                  "variableDesc": "Definir variáveis globais",
                  "gemini": "Gemini",
                  "geminiDesc": "Integração com Gemini",
                  "openai": "OpenAI",
                  "openaiDesc": "Integração com OpenAI"
            }
      },
      "floup": {
            "pageTitle": "Follow UP - Templates de Fluxo",
            "newTemplate": "Novo Template",
            "editTemplate": "Editar Template",
            "stepsCount": "{{count}} passos",
            "active": "Ativo",
            "inactive": "Inativo",
            "custom": "Personalizado",
            "basicInfo": "Informações Básicas",
            "templateName": "Nome do Template",
            "templateType": "Tipo do Template",
            "typeClient": "Cliente",
            "typeLead": "Lead",
            "typeCustom": "Personalizado",
            "description": "Descrição",
            "triggerConditionTitle": "Condição para Acionamento",
            "triggerConditionDesc": "Defina quando este Follow UP deve ser ativado. Uma vez ativado, todos os passos serão executados sequencialmente, até que as condições de parada sejam atendidas.",
            "conditionLabel": "Condição",
            "condQueue": "Fila do sistema",
            "condTag": "Tag do sistema",
            "condFirstClient": "Primeira interação do cliente",
            "condFirstAttendant": "Primeira interação do atendente",
            "queueLabel": "Fila",
            "selectQueue": "Selecionar fila",
            "tagLabel": "Tag",
            "selectTag": "Selecionar tag",
            "condDescLabel": "Descrição da condição",
            "templateClientTitle": "Template para Clientes",
            "templateClientDesc": "Fluxo automatizado para clientes existentes",
            "templateLeadTitle": "Template para Leads",
            "templateLeadDesc": "Fluxo de nutrição para novos leads",
            "templateCustomTitle": "Template Personalizado",
            "templateCustomDesc": "Crie seu próprio fluxo com condições específicas",
            "stopControlsTitle": "Controles de Parada do Fluxo",
            "stopAnyMessage": "1. Caso o Contato responder qualquer mensagem",
            "stopKeyword": "2. Caso o Contato responder uma Palavra chave",
            "stopKeywordLabel": "Palavra chave",
            "stopTicketClosed": "3. Caso o Ticket for Fechado",
            "flowStepsTitle": "Passos do Fluxo",
            "addStep": "Adicionar Passo",
            "cancel": "Cancelar",
            "saveTemplate": "Salvar Template"
      },
      "esqueceuSenha": {
            "title": "Esqueceu sua senha?",
            "subtitle": "Digite seu email cadastrado e enviaremos um código de recuperação.",
            "emailPlaceholder": "seu.email@exemplo.com",
            "sendCode": "Enviar Código",
            "sending": "Enviando..."
      }
}
  }
};

export { messages };
